import type { Messages } from '../t.ts'

/**
 * 영어 사전(통합 콘솔). 용어 기준은 `docs/i18n-glossary-en.md` — 작업은 Task 다(Batch 를 쓰지 않는다 · eric 2026-11-02).
 * 빠진 키는 `t()` 가 `ko` 로 떨어진다. 키는 전부 `ko` 에 있는 키여야 한다(타입이 건다).
 */
export const en: Partial<Messages> = {
  'batchHalt.title': 'Task halted',
  'batchHalt.estopTitle': 'E-STOP active',
  'batchHalt.open': 'Action',
  'batchHalt.paused': 'Task paused.',
  'batchHalt.unknown': 'Halt cause not received from server yet.',
  'batchHalt.module': 'Related Equipment',
  'batchHalt.moduleOpen': 'Equipment details',
  'batchHalt.details': 'Task details',
  'batchHalt.lockManage': 'Go to Control Lock',
  'batchHalt.lockHint':
    'Manage it from the Control Lock on the top Task Bar. The cause and stop list are viewable without it.',
  'batchHalt.cause': 'Cause',
  'batchHalt.steps': 'Resolution steps',
  'batchHalt.lockOther': 'That user must release the Control Lock before stops can be released',
  'batchHalt.lockMine': 'Held by me',
  'batchHalt.lockHolder': 'Held by {holder}',
  'batchHalt.stops': 'Release stops',
  'batchHalt.recover': 'Recovery decision',
  'batchHalt.stale':
    "Can't confirm the latest state. Showing the last received content; controls are disabled.",
  'app.userMenu': 'User menu',
  'app.navToggle': 'Collapse sidebar',
  'app.navCollapse': 'Collapse',
  'app.navExpand': 'Expand',
  'app.version': 'Version',
  'app.logout': 'Log out',
  'app.home': 'Home',
  'app.notFound': 'Screen not found',
  'app.notFound.body': "The address has changed or the screen doesn't exist",
  'app.back': 'Previous screen',
  'app.renderError': "Couldn't render the screen",
  'app.renderError.body': 'Only this screen stopped. Try again or go to another screen',
  'app.renderError.fatalBody': 'The whole app must be redrawn',
  'app.renderError.detail': 'Error details',
  'app.retry': 'Retry',
  'app.reload': 'Reload',
  'auth.account': 'ID',
  'auth.failed': 'Authentication failed — check your ID and password',
  'auth.clearField': 'Clear {field}',
  'auth.password': 'Password',
  'auth.passwordReveal': 'Show password',
  'auth.remember': 'Stay logged in',
  'auth.submit': 'Log in',
  'auth.pinLogin': 'PIN login',
  'auth.readOnly': 'Read only',
  'auth.auto.missing.title': 'Auto-login account is not set',
  'auth.auto.missing.text':
    'This screen logs in by itself with a preset account. Fill in moduleAccount (ID · password) in the deployment settings',
  'auth.auto.rejected.title': 'Auto-login failed',
  'auth.auto.rejected.text':
    "The server rejected the configured account. Check the ID, password, and account lock. It won't retry by itself, to avoid locking the account",
  'auth.auto.transport': "Can't reach the server. Reconnecting shortly",
  'theme.label': 'Theme',
  'theme.system': 'System',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'accent.label': 'Theme color',
  'accent.blue': 'Blue',
  'accent.ink': 'Black',
  'nav.aria': 'Main menu',
  'nav.group.ops': 'Operations',
  'nav.group.res': 'Resources',
  'nav.group.sys': 'System',
  'nav.item.monitoring': 'Monitoring',
  'nav.item.batches': 'Tasks',
  'nav.item.batchHistory': 'History',
  'nav.item.alarms': 'Alarms',
  'nav.item.resources': 'Task Setup',
  'nav.item.samples': 'Samples',
  'nav.item.recipes': 'Recipes',
  'nav.item.templates': 'Templates',
  'nav.item.modules': 'Modules',
  'nav.item.logs': 'Logs',
  'nav.item.admin': 'Admin',
  'nav.item.account': 'Settings',
  'nav.brandHome': 'Go to Monitoring',
  'nav.alarmBadge': 'Active Alarms: {count}',
  'nav.alarmBadgeAtLeast': 'Active Alarms: at least {count}',
  'nav.alarmBadgeSevere': 'Includes high severity',
  'nav.moduleBadge': 'Modules needing attention: {count}',
  'screen.login.title': 'Log in',
  'login.tagline.line1': 'Oncology Research Platform',
  'login.tagline.line2': 'Circulating Tumor Cells for Drug Discovery',
  'screen.monitoring.title': 'Monitoring',
  'screen.monitoringModule.title': 'Monitoring · Module',
  'screen.batches.title': 'Tasks',
  'screen.opsGroup.title': 'Tasks',
  'screen.resourcesGroup.title': 'Task Setup',
  'screen.batchNew.title': 'New Task',
  'screen.batchAdd.title': 'Add Task',
  'screen.batchDetail.title': 'Task details',
  'screen.batchHistory.title': 'History',
  'screen.batchHistoryDetail.title': 'History · Task details',
  'screen.alarms.title': 'Alarms',
  'screen.samples.title': 'Samples',
  'screen.sampleNew.title': 'Add Sample',
  'screen.sampleDetail.title': 'Sample details',
  'screen.recipes.title': 'Recipes',
  'screen.recipeNew.title': 'Add Recipe',
  'screen.recipeDetail.title': 'Recipe details',
  'screen.modules.title': 'Modules',
  'screen.moduleDetail.title': 'Module details',
  'screen.calibrationDetail.title': 'Calibration details',
  'screen.logs.title': 'Logs',
  'screen.admin.title': 'Admin',
  'screen.userNew.title': 'Add user',
  'screen.userDetail.title': 'User details',
  'screen.userDeactivate.title': 'Deactivate account',
  'screen.userLock.title': 'Lock account',
  'screen.userUnlock.title': 'Unlock account',
  'screen.userPassword.title': 'Reset password',
  'screen.userRole.title': 'Change role',
  'screen.sessionRevoke.title': 'Force end session',
  'screen.account.title': 'Settings',
  'screen.tablet.title': 'Tablet',
  'screen.module.title': 'Module',
  'screen.diagnostics.title': 'Self-diagnostics',
  'tab.ops.batches': 'Running',
  'tab.batches.recover': 'Awaiting recovery',
  'card.batchDetail.samples': 'Samples',
  'card.batchDetail.cmds': 'Commands',
  'card.batchDetail.events': 'Event log',
  'card.batchDetail.trays': 'Load · Unload',
  'tab.alarms.all': 'All',
  'tab.alarms.active': 'Active',
  'tab.alarms.acknowledged': 'Acknowledged',
  'tab.alarms.cleared': 'Cleared',
  'tab.logs.event': 'Events',
  'tab.logs.syslog': 'System',
  'tab.logs.audit': 'Audit',
  'tab.samples.all': 'All',
  'tab.samples.in_process': 'In progress',
  'tab.samples.completed': 'Used',
  'tab.samples.discarded': 'Discarded',
  'tab.recipeDetail.overview': 'Overview',
  'tab.recipeDetail.parameters': 'Task inputs',
  'tab.recipeDetail.labware': 'Labware',
  'tab.recipeDetail.reagents': 'Reagents',
  'tab.recipeDetail.steps': 'Steps',
  'tab.moduleDetail.cal': 'Calibration',
  'tab.admin.general': 'Settings',
  'tab.admin.webhooks': 'Webhooks',
  'admin.general.empty': 'No settings available yet',
  'tab.admin.members': 'Users',
  'tab.monitoring.samples': 'Samples',
  'monitoring.deviceSelect.equipment': 'Equipment',
  'monitoring.deviceSelect.modules': 'Select Equipment',
  'monitoring.deviceSelect.running': 'Running',
  'monitoring.deviceSelect.short.cent': 'Cent',
  'monitoring.deviceSelect.short.asm': 'Asm',
  'monitoring.deviceSelect.short.stain': 'Stain',
  'monitoring.deviceSelect.robot': 'Transfer Robot',
  'monitoring.deviceSelect.short.robot': 'Robot',
  'monitoring.side.title': 'Consumables',
  'monitoring.view.label': 'View',
  'monitoring.view.none': 'Open a view from the left',
  'monitoring.samplesLocked': "viewer can't see Sample (PII) views",
  'figTab.all': 'All',
  'figTab.trays': 'Trays',
  'figTab.cent': 'Centrifuge',
  'figTab.vision': 'Vision',
  'figTab.gantry': '3-Axis Robot',
  'figTab.tc': 'TC Rack',
  'figTab.asm': 'Assembler',
  'figTab.tray': 'Tray',
  'figTab.pip': 'Pipette · Reagent',
  'figTab.shaker': 'Shaker',
  'figTab.maint': 'Maintenance',
  'figTab.aria': 'Display items',
  'figure.visionCamera': 'Vision camera · inspection',
  'figure.pick': 'View {name}',
  'activity.now': 'Running',
  'activity.paused': 'Halted',
  'activity.aria': '{name} — working now',
  'activity.at.inlet_tray': 'Inlet Tray',
  'activity.at.outlet_tray': 'Outlet Tray',
  'activity.at.rotor_slot': 'Rotor',
  'activity.at.counterweight_station': 'Counterweight slot',
  'activity.at.front_zone': 'Front',
  'activity.at.waste_container': 'Waste bin',
  'activity.at.equipment_stage': 'Assembly stage',
  'activity.at.tc_rack': 'TC Rack',
  'activity.at.reagent_bay': 'Reagent bay',
  'activity.at.tip_bay': 'Tip Rack',
  'activity.at.shaker': 'Shaker',
  'activity.slot': '{name} #{index}',
  'activity.move': '{from} → {to}',
  'activity.to': '{to}',
  'activity.wells': 'Wells {wells}',
  'column.time': 'Time',
  'column.severity': 'Severity',
  'column.module': 'Module',
  'column.content': 'Content',
  'column.target': 'Target',
  'column.result': 'Result',
  'column.kind': 'Type',
  'column.sampleType': 'Type',
  'column.category': 'Category',
  'column.status': 'Status',
  'column.version': 'Version',
  'column.step': 'Step',
  'column.updated': 'Updated',
  'column.name': 'Name',
  'column.role': 'Role',
  'column.owner': 'Owner',
  'column.sampleCount': 'Samples',
  'column.duration': 'Duration',
  'column.sample': 'Sample',
  'column.startedAt': 'Started',
  'column.progress': 'Progress',
  'column.report': 'Report',
  'column.format': 'Format',
  'column.createdAt': 'Created',
  'column.actor': 'Actor',
  'column.action': 'Action',
  'column.reason': 'Reason',
  'column.reasonChange': 'Reason · Change',
  'column.source': 'Source',
  'column.message': 'Message',
  'column.item': 'Item',
  'column.performedAt': 'Performed',
  'column.nextDue': 'Next due',
  'column.accountId': 'Account ID',
  'column.email': 'Email',
  'column.lastActive': 'Last active',
  'column.lastLogin': 'Last login',
  'column.ipAddress': 'IP address',
  'column.moduleId': 'Module ID',
  'column.link': 'Link',
  'column.safety': 'Safety',
  'column.heartbeat': 'Heartbeat',
  'column.lastDiagnostic': 'Last diagnostic',
  'column.calibration': 'Calibration',
  'column.recipe': 'Recipe',
  'column.batch': 'Task',
  'column.batchId': 'Task ID',
  'column.well': 'Well',
  'column.bay': 'Bay',
  'column.layoutDetail': 'Detail level',
  'column.usedByRecipes': 'Used in Recipes',
  'column.labware': 'Labware',
  'column.sampleId': 'Sample ID',
  'column.patientId': 'Patient ID',
  'column.currentLocation': 'Current Module · location',
  'column.registered': 'Registered',
  'column.drawDateCancer': 'Draw date · Cancer type',
  'column.average': 'Average',
  'column.range': 'Range',
  'column.deviation': 'Deviation',
  'column.verdict': 'Verdict',
  'column.slot': 'Slot',
  'column.cell': 'Slot',
  'column.location': 'Location',
  'column.channel': 'Channel',
  'column.reagent': 'Reagent',
  'column.remaining': 'Remaining',
  'column.evidence': 'Evidence',
  'column.attribution': 'Attribution',
  'column.event': 'Event',
  'column.alarm': 'Alarm',
  'column.occurredAt': 'Occurred',
  'column.alarmOccurredAt': 'Occurred at',
  'column.usedByBatches': 'Used in Tasks',
  'column.correlationId': 'Correlation ID',
  'column.operation': 'Operation',
  'column.logLevel': 'Level',
  'column.metric': 'Metric',
  'filter.all': 'All',
  'filter.active': 'Active',
  'filter.period': 'Period',
  'filter.severity': 'Severity',
  'filter.module': 'Module',
  'filter.attribution': 'Attribution',
  'filter.batch': 'Task',
  'filter.status': 'Status',
  'filter.layoutDetail': 'Detail level',
  'filter.source': 'Source',
  'filter.actor': 'Actor',
  'filter.kind': 'Type',
  'filter.logLevel': 'Level',
  'filter.category': 'Category',
  'filter.search.alarms': 'Search code · Module · content',
  'filter.search.batches': 'Search Task ID · Recipe',
  'filter.search.batchesWithOwner': 'Search Task ID · Recipe · owner',
  'filter.search.batchesPlaceholder': 'Search',
  'filter.search.recipes': 'Search name',
  'filter.search.recipesWithOwner': 'Search name · owner',
  'filter.search.events': 'Search content · Module',
  'filter.search.syslog': 'Search message · source',
  'filter.search.audit': 'Search actor · target · reason',
  'filter.search.users': 'Search account ID · name',
  'action.start': 'Start',
  'action.pause': 'Pause',
  'action.resume': 'Resume',
  'action.stop': 'Stop',
  'action.recover': 'Recover',
  'action.estop': 'E-STOP',
  'action.clearSafety': 'Clear safety',
  'action.showCause': 'Show cause',
  'action.loadDone': 'Load done',
  'action.unloadDone': 'Unload done',
  'action.selectBatch': 'Select Task',
  'strip.picker.empty': 'No waiting Tasks',
  'strip.picker.clear': 'Clear selected Task',
  'reason.stripBatchStarted': "A started Task can't be changed — pick again when it ends",
  'action.newBatch': '＋ Add Task',
  'action.manualMode': 'Manual',
  'action.manualEnd': 'End',
  'action.cancel': 'Cancel',
  'action.save': 'Save',
  'action.close': 'Close',
  'action.add': 'Add',
  'action.change': 'Change',
  'action.export': 'Export',
  'action.commit': 'Commit',
  'action.acquireLock': 'Acquire',
  'action.reacquireLock': 'Reacquire',
  'action.releaseLock': 'Release',
  'action.forceReleaseLock': 'Force release',
  'action.runDiagnostics': 'Diagnose',
  'action.back': 'Back',
  'action.eventsExpand': 'Events',
  'action.toMaintTab': 'Maintenance tab →',
  'action.openInSamples': 'View in Samples',
  'action.copyId': 'Copy full ID',
  'state.copied': 'Copied',
  'reason.clipboardUnavailable': "Can't copy on this screen",
  'error.copyFailed': "Couldn't copy",
  'strip.label': 'Task Bar',
  'strip.waitingBatches': 'Waiting Tasks',
  'strip.prevStep': 'Previous step',
  'strip.currentStep': 'Current step',
  'strip.nextStep': 'Next step',
  'strip.eventsExpand': 'Expand',
  'strip.eventsCollapse': 'Collapse',
  'strip.foldCollapse': 'Collapse Task Bar',
  'strip.foldExpand': 'Expand Task Bar',
  'strip.eventsCaption': 'Events of this Task',
  'strip.eventsNoBatch': 'No Task',
  'strip.eventsStale': "Disconnected — new events aren't reflected",
  'strip.eventsNew': 'New events: {count}',
  'strip.eventsFilter': 'Event type',
  'strip.eventsFilter.all': 'All',
  'strip.eventsFilter.step': 'Step',
  'strip.eventsFilter.state': 'State change',
  'strip.eventsFilter.other': 'Other',
  'strip.eventsKindStep': 'Step',
  'pagination.label': 'Pagination',
  'pagination.prev': 'Previous',
  'pagination.next': 'Next',
  'pagination.status': 'Page {page} / {pages}',
  'event.content.stateChange': '{from} → {to}',
  'event.content.dispatchItems': 'Steps sent: {count}',
  'event.content.executionObserved': '{module} execution observed',
  'event.content.byActor': 'By {actor}',
  'event.content.stepCount': '{step}/{total}',
  'event.content.stepTotal': '{total} steps',
  'strip.openBatch': 'View Task details',
  'strip.openRecipe': 'View Recipe',
  'strip.manualTitle': 'Manual operation',
  'strip.estopTitle':
    'Stop request to all Modules · no confirmation dialog · regardless of role or Control Lock',
  'strip.estopSub': 'Full Emergency Stop',
  'strip.estopName': 'E-STOP · Full Emergency Stop',
  'strip.metaOwner': 'Owner',
  'strip.metaStarted': 'Started',
  'strip.notStarted': 'Not started',
  'strip.metaRecipe': 'Recipe',
  'strip.stage.done': 'Done',
  'strip.stage.run': 'Running',
  'strip.stage.wait': 'Waiting',
  'strip.stage.pause': 'Paused',
  'strip.stage.stop': 'Aborted',
  'strip.stage.hold.quarantined': 'Tray quarantined',
  'strip.stage.hold.dropped': 'Tray dropped',
  'strip.stage.stepsUnit': 'steps',
  'strip.stage.progress': '{module} progress {value}',
  'strip.zone.prep': 'Prep',
  'strip.zone.prepName': '{module} prep',
  'strip.zone.run': 'Running',
  'strip.zone.runName': '{module} running',
  'strip.zone.done': 'Done',
  'strip.zone.preparing': 'Preparing',
  'strip.zone.transfer': 'Transferring',
  'strip.flowLabel': 'Process flow',
  'strip.preflight.title': 'Preflight',
  'strip.preflight.checking': 'Checking',
  'strip.preflight.passed': 'Passed',
  'strip.preflight.blocked': 'Blocked',
  'strip.tallyTotal': 'Total',
  'strip.tallyElapsed': 'Elapsed',
  'strip.tallySteps': 'Steps',
  'strip.tallyTime': 'Time',
  'strip.estimate.notSent': 'Not sent by the server yet',
  'halt.auto': 'Continues automatically',
  'halt.action': 'Action required',
  'halt.blockers': 'Blocking resume',
  'halt.confirm': 'On-site check required — continue with [Recover] «Redo stopped action»',
  'halt.checks': 'To check',
  'action.rerunCutAtom': 'Redo stopped action',
  'reason.resumeNeedsConfirm':
    'Continues only through [Recover] «Redo stopped action» after an on-site check',
  'reason.physicalChecksRequired': 'Check all items',
  'enum.resumeCheck.door_area': 'Nothing is caught around the door',
  'enum.resumeCheck.robot_area': 'Nothing is caught around the robot',
  'enum.resumeCheck.tray_positions': 'Trays are in place',
  'enum.resumeCheck.rotor_balanced': 'The Centrifuge rotor is balanced',
  'resume.checkGeneral':
    'Checked on site around the stopped action (Equipment · held items · Sample slots)',
  'resume.timedAtom': 'Interrupted spin · shake',
  'enum.timedAtom.restart': 'From start',
  'enum.timedAtom.remaining': 'Remaining time only',
  'strip.resumeTitle': 'Resume',
  'halt.facts': 'Halt info',
  'halt.code': 'Halt type',
  'halt.elapsed': 'Halted for',
  'halt.allowed': 'Allowed delay',
  'halt.since': 'Halted at',
  'halt.delayState': 'Delay status',
  'enum.haltDelay.ok': 'Within limit',
  'enum.haltDelay.warn': 'Over 80% of limit',
  'enum.haltDelay.exceeded': 'Over limit',
  'enum.haltDelay.inconclusive': 'Inconclusive',
  'halt.module': 'Halted Module',
  'halt.remoteAt': 'Remote call planned',
  'strip.briefOf': 'Process {index} / {count}',
  'action.openMonitoring': 'View in Monitoring',
  'action.eventsLog': 'Event log',
  'action.eventLogDownload': 'Download event log',
  'action.eventLogDownloadShort': 'Download',
  'eventLog.downloading': 'Downloading…',
  'eventLog.empty': 'No records for this Task',
  'eventLog.truncated': 'Too many records; download stopped at {fetched}',
  'eventLog.fileTag': 'event-log',
  'logs.export.title': 'Logs',
  'logs.export.asOf': 'Exported at',
  'logs.export.rowCount': 'Rows',
  'logs.export.fileTag': 'logs',
  'logs.export.empty': 'No rows to export',
  'logs.export.saving': 'Exporting…',
  'eventLog.csv.batchName': 'Task name',
  'eventLog.csv.batchId': 'Task ID',
  'eventLog.csv.status': 'Task status',
  'eventLog.csv.asOf': 'As of',
  'eventLog.csv.asOfValue': 'Through {at}',
  'eventLog.csv.rowCount': 'Rows',
  'eventLog.csv.time': 'Time',
  'eventLog.csv.isoTime': 'Time (raw)',
  'eventLog.csv.ledger': 'Ledger',
  'eventLog.csv.errorCode': 'Error code',
  'eventLog.csv.errorMessage': 'Error message',
  'eventLog.csv.executionId': 'Execution ID',
  'eventLog.csv.commandId': 'Command ID',
  'eventLog.csv.context': 'Context',
  'eventLog.csv.extra': 'Other',
  'strip.moduleStep': 'Module step {value}',
  'strip.totalStep': 'Total step {value}',
  'strip.totalStepPartial': 'Step count is unknown for Modules not started yet',
  'strip.totalStepEstimated': 'Includes estimates from past Tasks',
  'strip.moduleStepEstimated': 'Based on past Tasks',
  'strip.moduleStepAt': '{module} {value}',
  'strip.dismissError': 'Dismiss failure message',
  'strip.disposition.text': 'Sample disposition pending — Task {id}',
  'strip.disposition.more': '+{count} more',
  'strip.disposition.open': 'Resolve in History →',
  'strip.disposition.title':
    "Samples of Task {id} are not yet disposed. This notice goes away once they're disposed in Task details (History).",
  'strip.disposition.dismiss': "Hide this notice — the server's pending disposition stays",
  'disposition.title': 'Sample disposition',
  'disposition.submit': 'Commit disposition',
  'disposition.rerun': 'Rerun',
  'disposition.discard': 'Discard',
  'disposition.allRerun': 'Rerun all',
  'disposition.allDiscard': 'Discard all',
  'disposition.choice': 'Disposition',
  'disposition.note': 'Note',
  'disposition.done': 'Processed',
  'disposition.refused':
    'Not accepted — the server refused (choose Discard if outside rerun conditions)',
  'disposition.rerunBlocked': 'Processing has started — only Discard is accepted',
  'disposition.empty': 'No Samples to dispose in this Task (in progress · awaiting decision)',
  'disposition.failed': '{decision} failed — {message}',
  'disposition.help.rerun':
    'Rerun — releases the Sample from this Task and returns it to the registered step. It can go into a new Task, and the old history stays. Accepted only for Samples at the registered step with no dispense record in this Task.',
  'disposition.help.discard': 'Discard — discards the Sample. The Task stays aborted.',
  'disposition.help.reason':
    "A reason is required for both and stays in the audit log (for Discard, also as the Sample's discard reason).",
  'strip.execCancel.failed': 'Equipment is still running — {items}',
  'strip.execCancel.item': '{module} {reason}',
  'strip.execCancel.itemCode': '{module} {reason} ({code})',
  'strip.execCancel.lookupFailed':
    "Equipment may still be running — couldn't send Cancel execution: {reason}",
  'strip.execCancel.leftover': 'Execution from an ended Task remains on the Equipment — {modules}',
  'strip.execCancel.waiting':
    'Cancel execution sent — waiting for the Equipment to stop: {modules}',
  'strip.execCancel.leftoverReason': 'Cancel leftover execution of ended Task',
  'action.cancelExecution': 'Cancel execution',
  'action.retryCancelExecution': 'Retry',
  'strip.noProgress': 'No progress info',
  'strip.elapsed': 'Elapsed {time}',
  'strip.duration': 'Duration {time}',
  'strip.safetyCritical': 'Safety Stop · CRITICAL: {count}',
  'strip.segments': 'Segment progress',
  'strip.stopTitle': 'Stop Task',
  'strip.stopConfirmText': 'Stop this Task?',
  'strip.stopReasonDefault': 'No reason entered',
  'strip.startTitle': 'Start Task',
  'strip.reagentTitle': 'Confirm reagent volume',
  'strip.reagentModule': 'Target Module',
  'strip.reagentBasis': 'Basis',
  'strip.reagentBasisValue': 'Recipe standard fill · not measured · editable',
  'strip.reagentTargetUnknown':
    "Target undecided — the server couldn't determine the Stainer Module for the reagent refill confirmation (none active, or more than one)",
  'strip.reagentUnplaced': '{reagent} — reservoir unknown, not recorded',
  'strip.reagentWell': '{reagent} {well} volume after refill (µL)',
  'strip.reagentNote': 'Pre-start reagent check · {batch}',
  'action.confirmAndStart': 'Confirm and start',
  'reason.reagentTargetUnknown': 'No Stainer Module determined for the reagent refill',
  'reason.reagentVolumeInvalid': 'Volume must be a number of 0 or more',
  'strip.warnAckChanged': 'The warning list changed — check it again',
  'strip.warnAckMissing':
    "Your confirmation didn't reach the server — check the warnings below again",
  'strip.recoverTitle': 'Recovery decision',
  'strip.recoverDecision': 'Decision',
  'lock.label': 'Control Lock',
  'lock.none': 'None',
  'lock.unknown': 'Control Lock status unavailable',
  'lock.holderUnknown': 'Held by another user · name unknown',
  'lock.heldBy': 'Held by {name}',
  'strip.stopUnreachedChip': 'Not stopped: {count} · {modules}',
  'strip.safetyStopped': 'Safety Stop',
  'lock.noPermission': 'No permission',
  'lock.expiresAt': 'Expires',
  'lock.expired': 'Expired',
  'lock.heldByMe': 'Held by me',
  'lock.heldByOther': 'Held by another user',
  'lock.releaseReason': 'User release',
  'lock.forceReleaseTitle': 'Force release Control Lock',
  'safety.estopped': 'Safety Stop',
  'safety.controlDisabled': 'Disconnected — no control',
  'safety.moduleStale': 'No response',
  'stale.lastSeen': 'Last response {time}',
  'stale.lastValue': '{value} · last value',
  'panel.metricsStale': 'Last metrics',
  'reason.noPermission': 'No {perm} permission',
  'reason.usersAdminOnly': 'Only admin can view user management',
  'reason.lockRequired': 'Control Lock required',
  'reason.estopActive': 'Emergency Stop active — available after Clear safety',
  'reason.batchBusy': 'Task in motion — controls locked',
  'reason.manualOnly': 'Manual mode only',
  'reason.batchActive': 'Active Task exists',
  'reason.pinRequired': 'PIN login required',
  'reason.noRunningBatch': 'No Task in progress',
  'reason.noRecoveryPending': 'No recovery pending',
  'reason.manualInProgress': 'Manual in progress — end it, then start',
  'reason.streamStale': 'Disconnected — no control',
  'reason.commandNotAllowed': 'Not available in the current state',
  'reason.stopWhileHalted': 'End a halted Task with [Recover › Discard]',
  'reason.recoverEnded': "Ended Tasks don't accept resume, discard, or confirm completion",
  'reason.recoverEndedHandoff':
    "Ended Tasks don't accept resume, discard, or confirm completion — release the Handoff quarantine with [Clear Tray bay] first, then [Sample disposition] opens",
  'reason.pinEmpty': 'Enter the PIN',
  'reason.confirmRequired': 'Check the confirmation box',
  'reason.noRouteHere': "Can't navigate from this screen",
  'startBlock.title': "Why it can't start",
  'startBlock.role': "This role can't start",
  'startBlock.lock': 'Control Lock not held',
  'startBlock.otherBatch': 'Another Task ({name}) is {status}',
  'startBlock.preflight': 'Preflight blocked — {codes}',
  'startBlock.preflightPending': 'Preflight result not received yet',
  'startBlock.serverOnly': "The server doesn't allow start (no reason given)",
  'state.loading': 'Loading',
  'state.preparing': 'Preparing',
  'state.denied.banner': 'No permission — {perm} required · current role {role}',
  'state.denied.screen': 'The screen stays visible but locked; all writes are disabled',
  'state.empty.generic': 'None',
  'table.rowCount': 'Rows: {count}',
  'state.empty.recipes': 'No Recipes in use',
  'state.empty.sessions': 'No active sessions',
  'state.sessionsExpiredHidden': 'Expired, hidden: {count}',
  'state.empty.alarms': 'No Alarms',
  'state.empty.batches': 'No Tasks',
  'state.empty.samples': 'No Samples',
  'state.empty.events': 'No events',
  'state.notShown': 'Content unavailable',
  'validation.password.minLength': 'At least {n} characters',
  'validation.password.kinds': 'At least {n} of: uppercase, lowercase, number, special character',
  'confirm.load.title': 'Confirm load',
  'confirm.load.subject': 'Centrifuge · front inbound holder',
  'confirm.load.item.chambers': '9 HypICC Chambers (A1~C3)',
  'confirm.load.item.counterweight': '1 R″ counterweight — left slot by the handle',
  'confirm.load.item.seated': 'Tray fully seated on the holder',
  'confirm.load.submit': 'Confirm load',
  'confirm.unload.title': 'Confirm unload',
  'confirm.unload.subject': 'Stainer · front unload bay',
  'confirm.unload.item.allOut': 'All L Trays taken out (including stain failures)',
  'confirm.unload.item.bayEmpty': 'Unload bay confirmed empty',
  'confirm.unload.submit': 'Confirm unload',
  'confirm.start.title': 'Pre-start check',
  'confirm.start.submit': 'Start',
  'confirm.checked': 'I checked the items above',
  'confirm.warnAck': 'I acknowledge the warnings and start',
  'module.cent': 'Centrifuge',
  'module.asm': 'Assembler',
  'module.stain': 'Stainer',
  'module.robot': 'Transfer Robot',
  'module.vision': 'Vision camera',
  'module.safety': 'Safety system',
  'module.system': 'System',
  'panel.metrics': 'Current metrics',
  'panel.progress': 'Progress',
  'panel.chambers': 'Chambers',
  'panel.info': 'Info',
  'panel.detailTitle': '{name} details',
  'panel.chambersOf': '{name} Chambers',
  'panel.unreceived': 'Not received',
  'panel.alarmCount': 'Alarms: {count}',
  'panel.slots': 'Slots',
  'panel.channels': 'Channels',
  'panel.lastInspection': 'Last inspection',
  'panel.verdictByTarget': 'Verdict by item',
  'panel.device': 'Device',
  'panel.controlOwner': 'Control owner',
  'panel.hold': 'Hold',
  'panel.holdSince': 'Hold since',
  'panel.lastDiagnostic': 'Last diagnostic',
  'panel.remainingSamples': 'Remaining Samples',
  'panel.inProgress': 'Running',
  'panel.done': 'Done',
  'panel.aria': 'Selected item details',
  'panel.legend': 'Legend',
  'pad.runDemo': 'Run demo',
  'pad.confirmHere': 'Confirm · this pad',
  'pin.title': 'PIN unlock',
  'pin.entered': 'Digits entered: {count}',
  'pin.clear': 'Clear all',
  'pin.clearShort': 'All',
  'pin.backspace': 'Delete one',
  'pin.backspaceShort': '⌫',
  'pin.submit': 'Unlock',
  'pin.checking': 'Checking',
  'maint.group.diag': 'Diagnostics · Calibration',
  'maint.toLocal': 'Switch to Local mode',
  'maint.toLocalHint': 'This pad takes control · shown locked on the console',
  'maint.toSystem': 'Exit Local mode',
  'maint.toSystemHint': 'Returns to system · re-runs Preflight',
  'maint.confirmToLocal': 'Bring console control to this pad',
  'maint.confirmToSystem': 'Return control to the system',
  'maint.validUntil': 'Next {at}',
  'stepper.newBatch.sample': 'Sample',
  'stepper.newBatch.recipe': 'Recipe',
  'enum.batchStatus.created': 'Waiting',
  'enum.batchStatus.queued': 'Queued',
  'enum.batchStatus.running': 'Running',
  'enum.batchStatus.paused': 'Paused',
  'enum.batchStatus.completed': 'Completed',
  'enum.batchStatus.aborted': 'Aborted',
  'enum.batchStatus.error': 'Error',
  'enum.executionEvent.started': 'Started',
  'enum.executionEvent.progress': 'Progress',
  'enum.executionEvent.telemetry': 'Telemetry',
  'enum.executionEvent.step_complete': 'Step done',
  'enum.executionEvent.complete': 'Done',
  'enum.executionEvent.error': 'Error',
  'enum.executionEvent.cancelled': 'Canceled',
  'enum.executionEvent.aborted': 'Aborted',
  'enum.executionEvent.paused': 'Paused',
  'enum.executionEvent.resumed': 'Resumed',
  'enum.moduleState.IDLE': 'Idle',
  'enum.moduleState.ERROR': 'Error',
  'enum.moduleState.RECOVERY': 'Recovering',
  'enum.moduleState.ABORTED': 'Stopped by cancel',
  'enum.moduleState.INTERRUPTED': 'Awaiting re-send',
  'enum.moduleState.LOADING': 'Loading',
  'enum.moduleState.WAITING_FOR_MANUAL_LOAD': 'Awaiting load',
  'enum.moduleState.RUNNING': 'Running',
  'enum.moduleState.UNLOADING': 'Unloading',
  'enum.moduleState.TRAY_LOADING': 'Tray loading',
  'enum.moduleState.TRAY_UNLOADING': 'Tray unloading',
  'enum.moduleState.WAITING_FOR_MANUAL_TRAY_LOAD': 'Awaiting load',
  'enum.moduleState.WAITING_FOR_TRAY_UNLOAD': 'Awaiting robot unload',
  'enum.moduleState.WAITING_FOR_MANUAL_TRAY_UNLOAD': 'Awaiting manual unload',
  'enum.moduleState.WAITING_FOR_MANUAL_UNLOAD': 'Awaiting manual unload',
  'enum.moduleState.TC_LOAD': 'TC mount',
  'enum.moduleState.UV': 'UV exposure',
  'enum.moduleState.TC_REMOVE': 'TC removal',
  'enum.moduleState.ROTATE_DRAIN': 'Flip and drain',
  'enum.moduleState.OUTPUT': 'Output',
  'enum.moduleState.TIP_CHANGE': 'Tip change',
  'enum.moduleState.PIPETTING': 'Aspirating',
  'enum.moduleState.DISPENSING': 'Dispensing',
  'enum.moduleState.INCUBATING': 'Incubating',
  'enum.moduleState.SHAKING': 'Shaking',
  'enum.moduleState.WAITING': 'Step wait',
  'enum.moduleState.COMPLETE': 'Done',
  'enum.moduleState.WAITING_FOR_UNLOAD': 'Awaiting unload',
  'enum.moduleState.MOVING': 'Moving',
  'enum.moduleState.HOMING': 'Homing',
  'enum.moduleState.HANDOFF': 'Handoff',
  'enum.moduleState.SAFE_STOP': 'Safety Stop',
  'enum.moduleState.PAUSED': 'Paused',
  'enum.moduleState.STOPPED': 'Stopped',
  'enum.moduleState.MANUAL': 'Manual',
  'enum.moduleStateKind.idle': 'Idle',
  'enum.moduleStateKind.run': 'Running',
  'enum.moduleStateKind.wait': 'Needs action',
  'enum.moduleStateKind.err': 'Error',
  'enum.moduleStateKind.recovery': 'Recovering',
  'enum.moduleStateKind.stop': 'Safety Stop',
  'enum.moduleStateKind.pause': 'Paused',
  'enum.moduleStateKind.done': 'Done',
  'enum.moduleStateKind.manual': 'Manual',
  'enum.recipeStatus.draft': 'Draft',
  'enum.recipeStatus.committed': 'Committed',
  'enum.recipeStatus.archived': 'Archived',
  'enum.sampleStatus.in_process': 'In progress',
  'enum.sampleStatus.completed': 'Used',
  'enum.sampleStatus.discarded': 'Discarded',
  'enum.sampleStatus.awaiting_decision': 'Awaiting decision',
  'enum.controlOwner.orchestrator': 'System',
  'enum.controlOwner.local': 'Local',
  'enum.interlock.closed': 'Closed',
  'enum.interlock.door': 'Door open',
  'enum.interlock.light_curtain': 'Light curtain blocked',
  'enum.layoutDetail.simple': 'Simple',
  'enum.layoutDetail.full': 'Full',
  'enum.labwareType.hypicc_chamber': 'Chamber Tray',
  'enum.labwareType.reagent_reservoir': 'Reagent reservoir',
  'enum.labwareType.tip_rack': 'Tip Rack',
  'enum.verdict.pass': 'Pass',
  'enum.verdict.fail': 'Fail',
  'enum.verdict.inconclusive': 'Inconclusive',
  'enum.severity.CRITICAL': 'Critical',
  'enum.severity.ERROR': 'Error',
  'enum.severity.WARN': 'Warning',
  'enum.severity.INFO': 'Info',
  'enum.severity.DEBUG': 'Debug',
  'enum.alarmCategory.critical': 'Immediate stop',
  'enum.alarmCategory.unrecoverable': 'Call service',
  'enum.alarmCategory.user_recoverable': 'Action needed',
  'enum.alarmCategory.recoverable': 'Auto-recovery',
  'enum.alarmCategory.transient': 'Transient',
  'enum.safetyState.normal': 'Normal',
  'enum.safetyState.degraded': 'Caution',
  'enum.safetyState.emergency_stop': 'Safety Stop',
  'enum.safetyState.safe_shutdown': 'Service needed',
  'enum.safetyState.unknown': 'Unknown',
  'enum.reviewReason.recovery_decision': 'Awaiting recovery decision',
  'enum.reviewReason.completion_unobserved': 'Completion not observed',
  'enum.reviewReason.handoff_unconfirmed': 'Awaiting Handoff confirmation',
  'enum.reviewReason.sample_disposition': 'Awaiting Sample disposition',
  'enum.dispensesBasis.observed': 'Recorded (count 0 — needs checking)',
  'enum.dispensesBasis.none': 'None (this Recipe has no dispense step)',
  'enum.dispensesBasis.unobserved': "No record received (this doesn't mean there was no dispense)",
  'enum.dispensesBasis.unknown': "Inconclusive (couldn't read the Recipe body)",
  'role.admin': 'admin',
  'role.service': 'service',
  'role.operator': 'operator',
  'role.viewer': 'viewer',
  'role.admin.who': 'Customer admin · CTCells researcher',
  'role.service.who': 'Vendor service engineer',
  'role.operator.who': 'Customer operator',
  'role.viewer.who': 'Customer observer · medical staff',
  'perm.view': 'view',
  'perm.monitor': 'monitor',
  'perm.control': 'control',
  'perm.settings': 'settings',
  'perm.maintenance': 'maintenance',
  'action.ack': 'Acknowledge',
  'action.confirm': 'Confirm',
  'action.clearAlarm': 'Clear',
  'action.clearAllAlarms': 'Clear all',
  'alarm.bulkClear.title': 'Clear all Alarms',
  'alarm.bulkClear.confirm': 'Alarms to clear: {count}.',
  'alarm.bulkClear.held':
    "Alarms with a holding condition won't be cleared: {count}. They can be cleared after the condition resolves.",
  'alarm.bulkClear.sending': 'Clearing',
  'alarm.bulkClear.resultCleared': 'Cleared: {count}',
  'alarm.bulkClear.resultFailed': 'Failed: {count}',
  'alarm.bulkClear.failuresLabel': 'Failed Alarms',
  'alarm.bulkClear.failureItem': '{reason} — {count}',
  'alarm.bulkClear.failuresRemain': 'Failed Alarms stay in the list.',
  'error.exportTimeout': "Export didn't finish within the time limit",
  'error.exportFailed': "Couldn't create the export",
  'action.open': 'Open',
  'action.download': 'Download',
  'action.discard': 'Discard',
  'action.confirmCompleted': 'Confirm completion',
  'action.remove': 'Remove',
  'action.pick': 'Pick',
  'action.pickExisting': '＋ Add existing Sample',
  'action.newSample': '＋ Add new Sample',
  'action.addAndPick': 'Add and pick',
  'action.selectRecipe': 'Select Recipe',
  'action.createBatch': 'Create Task',
  'action.openBatch': 'Open Task details',
  'alarm.acknowledged': 'Acknowledged',
  'alarm.unacknowledged': 'Unacknowledged',
  'alarm.cleared': 'Cleared',
  'alarm.condition.resolved': 'Resolved',
  'alarm.condition.held': 'Holding',
  'screen.alarmDetail.title': 'Alarm details',
  'card.alarmOccurrence': 'Occurrence',
  'card.alarmHandling': 'Handling',
  'card.alarmDispatch': 'Dispatch',
  'row.errorCode': 'Code',
  'row.serverMessage': 'Server message',
  'row.groupingKey': 'Grouping key',
  'row.eventId': 'Event ID',
  'row.branch': 'Branch',
  'row.deviceError': 'Equipment error',
  'row.ackRequired': 'Acknowledgment required',
  'row.autoClear': 'Auto clear',
  'row.ackBy': 'Acknowledged by',
  'row.ackAt': 'Acknowledged at',
  'row.clearedAt': 'Cleared at',
  'state.empty.alarmNotFound': "This Alarm isn't in the list",
  'batchNew.quota': 'Picked: {picked}',
  'batchNew.capacityHint':
    'Choosing a Recipe sets the number of Sample slots — one Sample per well',
  'batchNew.tray.pickRecipe': 'Pick a Recipe to see the Sample slots',
  'reason.pickRecipeFirst': 'Pick a Recipe first',
  'batchNew.quotaOf': '{picked} / {slots}',
  'batchNew.newSample.title': 'New Sample',
  'batchNew.well.vacant': 'Well {well} · group {ref} · empty',
  'batchNew.well.filled': 'Well {well} · group {ref} · {sample}',
  'batchNew.well.title': '{well} ({ref})',
  'batchNew.well.picker': 'Select Sample for {well} ({ref})',
  'batchNew.well.current': 'This well',
  'batchNew.well.free': 'Available Samples',
  'batchNew.well.elsewhere': 'Assigned to another well',
  'batchNew.well.assigned': 'Samples assigned to existing Tasks (not selectable)',
  'batchNew.well.assignedReason':
    'Assigned to an existing Task. If that Task was aborted, check in its Sample disposition whether Rerun is possible',
  'batchNew.well.processedReason':
    "Processing has already started, so it can't be reused in a new Task. Check Sample disposition in the existing Task",
  'batchNew.well.inspectAssigned': 'Check existing Task',
  'batchNew.well.taken': 'Assigned to well {well}',
  'batchNew.well.clear': 'Remove',
  'batchNew.slot.group': 'Group',
  'batchNew.slot.pick': 'Pick Sample for well {well}',
  'batchNew.slot.patientMismatch': 'Patient ID differs',
  'batchNew.well.samePatient':
    'Same-patient group ({ref}) — showing only Samples with patient ID {patient}',
  'batchNew.well.samePatientEmpty': 'No Samples from the same patient',
  'reason.groupPatientMismatch': 'Group {refs} contains Samples with different patient IDs',
  'batchNew.tray.noSlots': "This Recipe doesn't report Sample slots, so wells can't be picked",
  'batchNew.recipe.detail': 'Details',
  'batchNew.recipe.detailOf': '{name} details',
  'batchNew.name.label': 'Name',
  'reason.batchNameUnsupported':
    "The server doesn't accept Task names yet — saved with an auto name",
  'batchNew.name.ignored':
    "The server doesn't accept names yet, so it was saved with the auto name “{saved}”",
  'reason.batchNameTooLong': 'Task name limit: {max} characters',
  'column.drawDate': 'Draw date',
  'column.cancerType': 'Cancer type',
  'column.cancerStage': 'Cancer stage',
  'kpi.waste': 'Waste bin',
  'kpi.tip': 'Tip',
  'kpi.reagentHeadroom': 'Reagent headroom',
  'kpi.reagentStorage': 'Reagent storage',
  'kpi.threshold': 'Threshold {value}',
  'kpi.capacity': '/ {value}',
  'kpi.required': 'Required {value}',
  'kpi.setpoint': 'Setpoint {value}',
  'metric.speed': 'Speed',
  'metric.rcf': 'RCF',
  'metric.temperature': 'Temp',
  'metric.axisX': 'X',
  'metric.axisY': 'Y',
  'metric.axisZ': 'Z',
  'metric.joint1': 'J1',
  'metric.joint2': 'J2',
  'metric.joint3': 'J3',
  'metric.joint4': 'J4',
  'metric.joint5': 'J5',
  'metric.joint6': 'J6',
  'metric.uv': 'UV',
  'metric.stage': 'Stage',
  'metric.tcRack': 'TC Rack',
  'metric.tip': 'Tip',
  'metric.gripper': 'Gripper',
  'metric.tipMounted': 'Tip',
  'metric.tipMounted.on': 'Mounted',
  'metric.tipMounted.off': 'None',
  'metric.reagentStorage': 'Reagent storage',
  'metric.shaker': 'Shaker',
  'metric.slider': 'Slider',
  'metric.verdict': 'Verdict',
  'monitoring.tray.C': 'C Tray',
  'monitoring.tray.A': 'A Tray',
  'monitoring.tray.L': 'L Tray',
  'monitoring.tray.Lrear': 'L Tray · rear',
  'monitoring.tray.Lfront': 'L Tray · front',
  'monitoring.tray.one': 'Tray',
  'monitoring.tray.visionPassed': 'Vision ✓',
  'monitoring.tray.visionFailed': 'Vision ✗',
  'monitoring.tray.visionRunning': 'Vision inspecting',
  'monitoring.tray.stage': '{tray} · {stage}',
  'monitoring.legend.before': 'Before',
  'monitoring.legend.after': 'After',
  'monitoring.eqsheet.steps': 'Task flow',
  'monitoring.eqsheet.layout': '{name} layout',
  'monitoring.eqsheet.processing': 'Processing',
  'monitoring.eqsheet.agitate': 'Shake',
  'monitoring.eqsheet.station': 'Press (TC mount) · UV exposure',
  'monitoring.eqsheet.process': '{name} process progress',
  'monitoring.eqsheet.metrics': '{name} metrics',
  'monitoring.eqsheet.gantry': '3-Axis Robot',
  'monitoring.centGripper.title': 'Centrifuge 3-axis gripper',
  'monitoring.asmGripper.title': 'Assembler 3-axis gripper',
  'monitoring.stainPipette.title': 'Stainer 3-axis pipette',
  'monitoring.eqsheet.latestStep': '{name} latest step',
  'monitoring.robot.gripper': 'Gripper',
  'monitoring.robot.grips.none': 'No gripper',
  'monitoring.robot.grips.unknown': 'Grip not published',
  'monitoring.robot.run': 'Execution',
  'monitoring.robot.run.none': 'No execution',
  'monitoring.robot.run.active': 'Running',
  'monitoring.robot.missing': 'No Module response',
  'monitoring.robot.pose.none': 'Pose not published — default pose icon',
  'monitoring.robot.pose.schematic': 'Schematic pose — {action}',
  'monitoring.robot.where.none': 'Location not published',
  'monitoring.robot.motion': 'Motion',
  'monitoring.robot.card': 'Robot',
  'monitoring.robot.state': 'State',
  'monitoring.robot.interlock': 'Interlock',
  'monitoring.robot.recovery': 'Recovery attempts',
  'monitoring.robot.spots.unpublished': 'Bay occupancy not published',
  'monitoring.robot.spots.none': 'No bays published',
  'monitoring.robot.position.tcp_x_mm': 'X',
  'monitoring.robot.position.tcp_y_mm': 'Y',
  'monitoring.robot.position.tcp_z_mm': 'Z',
  'monitoring.robot.position.tcp_rx_rad': 'RX',
  'monitoring.robot.position.tcp_ry_rad': 'RY',
  'monitoring.robot.position.tcp_rz_rad': 'RZ',
  'monitoring.robot.position.lift_mm': 'Lift axis',
  'monitoring.robot.position.traverse_mm': 'Traverse axis',
  'monitoring.robot.position.joint': 'Joint {n}',
  'monitoring.robotLine.park': 'P',
  'monitoring.robotLine.status': '{station} — {action}',
  'monitoring.robotLine.carrying': 'Carrying Tray',
  'monitoring.robotLine.carryingTray': 'Carrying {tray}',
  'monitoring.robotLine.door.front': 'Front door',
  'monitoring.robotLine.door.rear': 'Rear door',
  'enum.gripState.moving': 'Moving',
  'enum.gripState.at_target': 'Open',
  'enum.gripState.holding': 'Holding',
  'enum.gripState.dropped': 'Dropped',
  'enum.gripState.unknown': 'Inconclusive',
  'enum.robotSequence.move_to_module': 'Move to Module',
  'enum.robotSequence.move_aux_axis': 'Move travel axis',
  'enum.robotSequence.move_to_pose': 'Move to pose',
  'enum.robotSequence.grip': 'Grip',
  'enum.robotSequence.release': 'Release',
  'enum.robotSequence.gripper_set': 'Set gripper',
  'enum.robotSequence.home': 'Return to park',
  'enum.robotSequence.place_held': 'Place Tray',
  'monitoring.robot.point.slide_rear': 'Slide rear',
  'monitoring.robot.point.slide_front': 'Slide front',
  'monitoring.robot.point.slide': 'Slide',
  'monitoring.robot.point.tray_1': 'Tray holder',
  'monitoring.robot.point.grip_tray_on_holder': 'On holder',
  'monitoring.robot.point.grip_tray_on_slide': 'On slide',
  'monitoring.legend.checked': 'Location · Vision checked',
  'monitoring.live': 'Connected',
  'monitoring.reference': 'Reference',
  'monitoring.attributionInconclusive': 'Inconclusive',
  'monitoring.stop.rear': 'Rear',
  'monitoring.stop.pipetting': 'Pipetting',
  'monitoring.stop.front': 'Front',
  'monitoring.bay.ambient': 'Ambient 5',
  'monitoring.bay.chilled': 'Chilled 3 · 4 ℃',
  'monitoring.tipRack1': 'Tip Rack 1',
  'monitoring.tipRack2': 'Tip Rack 2',
  'monitoring.eqRack.tc': 'TC Rack',
  'monitoring.eqRack.tip1': 'Tip Rack1',
  'monitoring.eqRack.tip2': 'Tip Rack2',
  'monitoring.eqRack.tube': 'Tube Rack',
  'monitoring.waste': 'Waste bin',
  'monitoring.uvOn': 'UV on',
  'monitoring.uvOff': 'UV off',
  'monitoring.shakerLatch': 'Latch {state}',
  'monitoring.shaker.door': 'Rear door {state}',
  'monitoring.shaker.door.open': 'Open',
  'monitoring.shaker.door.closed': 'Closed',
  'monitoring.shaker.door.unknown': 'Not published',
  'figTab.pip3': 'Pipette 3-axis',
  'monitoring.eqsheet.stainFront': 'Pipette · Shaker',
  'monitoring.stainFront.stop': 'Bay {stop}',
  'monitoring.stainFront.bin.reagent': 'Tube Rack',
  'monitoring.stainFront.bin.waste': 'Waste bin',
  'enum.stainSequence.dispense_reagent': 'Dispensing',
  'enum.stainSequence.aspirate': 'Aspirate',
  'enum.stainSequence.draw': 'Draw reagent',
  'enum.stainSequence.expel': 'Expel',
  'enum.stainSequence.mix': 'Mix',
  'enum.stainSequence.shake': 'Shake',
  'enum.stainSequence.wait_with_temp_monitoring': 'Hold temp',
  'enum.stainSequence.move_to': 'Move',
  'enum.stainSequence.move_z': 'Move Z',
  'enum.stainSequence.mount_tip': 'Mount tip',
  'enum.stainSequence.discard_tip': 'Discard tip',
  'enum.stainSequence.open_door': 'Open rear door',
  'enum.stainSequence.close_door': 'Close rear door',
  'enum.stainSequence.slide_tray': 'Slide Tray',
  'enum.stainSequence.set_reagent_storage_temp': 'Set storage temp',
  'enum.stainSequence.inspect': 'Inspect',
  'enum.stainSequence.home_axes': 'Home axes',
  'enum.stainSequence.move_xy_mm': 'Move XY',
  'enum.stainSequence.detect_liquid': 'Detect liquid',
  'enum.stainSequence.shaker_latch': 'Latch shaker',
  'enum.stainSequence.shaker_unlatch': 'Unlatch shaker',
  'enum.stainSequence.shaker_stop': 'Stop shaker',
  'enum.stainSequence.shaker_heater_off': 'Heater off',
  'enum.stainSequence.reagent_storage_off': 'Cooling off',
  'enum.stainSequenceStep.dispense_reagent': 'Dispense',
  'enum.centSequence.run_centrifugation': 'Spin',
  'enum.centSequence.open_door': 'Open door',
  'enum.centSequence.close_door': 'Close door',
  'enum.centSequence.grip': 'Grip',
  'enum.centSequence.release': 'Release',
  'enum.centSequence.move_to': 'Move',
  'enum.centSequence.move_z': 'Move Z',
  'enum.centSequence.gripper_set': 'Set gripper',
  'enum.centSequence.rotate': 'Rotate',
  'enum.centSequence.wait_for_manual_load': 'Awaiting load',
  'enum.centSequence.inspect': 'Inspect',
  'enum.centSequence.slide_tray': 'Slide Tray',
  'enum.centSequence.home_axes': 'Home axes',
  'enum.centSequence.move_xy_mm': 'Move XY',
  'enum.asmSequence.expose_uv': 'UV exposure',
  'enum.asmSequence.grip': 'Grip',
  'enum.asmSequence.release': 'Release',
  'enum.asmSequence.move_to': 'Move',
  'enum.asmSequence.move_z': 'Move Z',
  'enum.asmSequence.gripper_set': 'Set gripper',
  'enum.asmSequence.rotate': 'Rotate',
  'enum.asmSequence.open_door': 'Open door',
  'enum.asmSequence.close_door': 'Close door',
  'enum.asmSequence.inspect': 'Inspect',
  'enum.asmSequence.slide_tray': 'Slide Tray',
  'enum.asmSequence.home_axes': 'Home axes',
  'enum.asmSequence.move_xy_mm': 'Move XY',
  'monitoring.noSlotAssignment': 'No slot info',
  'monitoring.noRotorLoad': 'No load info',
  'monitoring.noVisionFeed': 'No camera video connection',
  'vision.unsupported': "Video can't play on this screen — neither WebRTC nor MSE is supported",
  'vision.badge.connecting': 'Connecting',
  'vision.badge.failed': 'Connection failed',
  'vision.badge.unsupported': "Can't play",
  'vision.badge.none': 'Not connected',
  'vision.fullscreen.enter': '{device} video full screen',
  'vision.fullscreen.exit': 'Exit full screen',
  'vision.camera.pick': 'Select {device} camera',
  'monitoring.sampleCount': 'Samples: {count}',
  'monitoring.hold': 'Hold · {kind}',
  'enum.holdKind.user_pause': 'User pause',
  'enum.holdKind.emergency_stop': 'Emergency Stop',
  'enum.holdKind.safety_stop': 'Safety Stop',
  'enum.holdKind.grip_drop': 'Gripper drop',
  'enum.holdKind.protective_stop': 'Protective stop',
  'enum.holdKind.reagent_exhausted': 'Reagent exhausted',
  'enum.holdKind.tip_exhausted': 'Tip Rack exhausted',
  'enum.holdKind.orchestrator_pause': 'Auto pause',
  'monitoring.activeAlarms': 'Active Alarms: {count}',
  'monitoring.flow.stale': 'Disconnected — current step unknown',
  'monitoring.flow.cell.marked': 'Past',
  'monitoring.flow.cell.active': 'Running',
  'monitoring.flow.cell.pending': 'Waiting',
  'monitoring.flow.cell.pass': 'Success',
  'monitoring.flow.cell.fail': 'Failed',
  'monitoring.flow.cell.halted': 'Aborted',
  'monitoring.flow.groups.title': 'Chambers by Sample',
  'monitoring.flow.groups.patient': 'Sample {index}',
  'monitoring.flow.groups.openDetail': 'View details',
  'monitoring.flow.groups.working': 'Running',
  'monitoring.flow.groups.patientUnknown': 'Unknown Sample',
  'monitoring.flow.groups.unassigned': 'No assignment info',
  'monitoring.flow.groups.vacant': 'Unassigned',
  'monitoring.flow.groups.assignUnknown': 'Assignment unknown',
  'monitoring.flow.groups.noChamber': 'No Chamber assigned',
  'monitoring.flow.groups.noAssignment': 'No Chamber assignment info',
  'monitoring.flow.chamber': 'Chamber {well}',
  'monitoring.flow.vision.head': 'Vision · {device}',
  'monitoring.step.started': 'started',
  'monitoring.step.done': 'done',
  'monitoring.chamber.ready': 'Prep',
  'monitoring.chamber.recipeStep': 'Step {no}/{total}',
  'monitoring.phaseMark.centrifuge_waiting': 'Waiting',
  'monitoring.phaseMark.centrifuge_spinning': 'Spinning',
  'monitoring.phaseMark.centrifuge_done': 'Done',
  'monitoring.phaseMark.assembler_waiting': 'Waiting',
  'monitoring.phaseMark.assembler_cycle_running': 'Cycling',
  'monitoring.phaseMark.assembler_cycle_done': 'Cycle done',
  'monitoring.phaseMark.assembler_draining': 'Draining waste',
  'monitoring.phaseMark.assembler_done': 'Done',
  'monitoring.chamber.doing': 'Running',
  'monitoring.chamber.done': 'Done',
  'monitoring.chamber.transfer': 'In Handoff',
  'monitoring.chamber.dispense': 'Dispense',
  'monitoring.chamber.dispensing': 'Dispensing',
  'monitoring.chamber.dispenseStep': 'This dispense step: {step}',
  'monitoring.supply.tcStock': 'TC Rack',
  'monitoring.supply.chilledRack': 'Cold Rack',
  'monitoring.supply.tipRack': 'Tip Rack{index}',
  'monitoring.supply.tubeRack': 'Tube Rack{index}',
  'monitoring.supply.panel': 'Consumables status',
  'monitoring.supply.reagents': 'Reagents',
  'monitoring.supply.reagentPresent': '{present} of {total} present',
  'monitoring.supply.remainingOf': '{remaining} of {total} left',
  'monitoring.supply.ofTotal': '/{total}',
  'monitoring.supply.bay.ambient': 'Ambient bay {index}',
  'monitoring.supply.bay.chilled': 'Chilled bay',
  'monitoring.supply.bay.none': 'No bay assigned',
  'monitoring.supply.rackEmpty': 'No reagents on this rack',
  'monitoring.supply.spec.list': '{name} contents',
  'monitoring.supply.spec.tipsLeft': 'Tips left',
  'monitoring.supply.spec.tipsUsed': 'Tips used',
  'monitoring.supply.spec.tcLeft': 'TC left',
  'monitoring.supply.spec.tcUsed': 'TC used',
  'monitoring.supply.spec.total': 'Total',
  'monitoring.supply.foldHint': 'View details',
  'monitoring.supply.noRecipeRack': 'No reagent assignment info',
  'monitoring.supply.reagentList': 'Reagent presence',
  'monitoring.supply.presence.present': 'Present',
  'monitoring.supply.presence.absent': 'Absent',
  'monitoring.supply.celsius': '{celsius}℃',
  'monitoring.supply.storage': 'Storage {celsius}℃',
  'monitoring.supply.noRecipe': 'No running Task',
  'monitoring.supply.rackSplitUnknown': 'Per-rack not received',
  'monitoring.supply.tipsSum': 'Total {remaining}/{total}',
  'monitoring.supply.tipsMismatch': "Slot records don't match total",
  'monitoring.supply.tipsMismatchNote':
    "Per-slot usage records don't match the total reported by the Equipment — figure shown as full",
  'monitoring.supply.low': 'Low',
  'monitoring.supply.empty': 'Empty',
  'monitoring.supply.unreceived': 'Not received',
  'monitoring.supply.state.filled': 'Filled',
  'monitoring.supply.state.empty': 'Empty',
  'monitoring.supply.wells': 'By slot',
  'monitoring.supply.slotsUsed': 'Used slots',
  'monitoring.supply.slotsUsedAll': 'All slots used',
  'monitoring.supply.column.target': 'Target well',
  'monitoring.supply.column.volume': 'Volume',
  'monitoring.supply.column.rack': 'Rack',
  'monitoring.supply.lotExpiry': 'Exp. {date}',
  'monitoring.supply.result.ok': 'OK',
  'monitoring.supply.result.clog': 'Clogged',
  'monitoring.supply.result.foam': 'Foam',
  'monitoring.supply.result.absent': 'No liquid',
  'monitoring.supply.result.aborted': 'Aborted',
  'monitoring.supply.op.dispense': 'Dispense',
  'monitoring.supply.op.aspirate': 'Aspirate',
  'monitoring.supply.amount': 'Remaining',
  'monitoring.supply.currentOfTotal': 'Current {current} / Total {total}',
  'monitoring.supply.row.remaining': 'Remaining',
  'monitoring.supply.origin.live': 'Equipment report',
  'monitoring.supply.origin.default': 'No Equipment value — shown as full',
  'monitoring.supply.origin.partial': 'Partly not received — missing slots shown as full',
  'monitoring.supply.slotsNone': 'None',
  'monitoring.supply.replenish.action': 'Refill',
  'monitoring.supply.replenish.ask.tip': 'Did you load the tips?',
  'monitoring.supply.replenish.ask.tc': 'Did you load the TCs?',
  'monitoring.supply.replenish.lead':
    "Press [Yes] after you've actually refilled. This record can't be erased and keeps who refilled and when.",
  'monitoring.supply.replenish.yes': 'Yes',
  'monitoring.supply.replenish.no': 'No',
  'monitoring.supply.replenish.fullCount': '{count} (full)',
  'monitoring.supply.replenish.manual': 'Enter count · note',
  'monitoring.supply.replenish.kindLabel': 'Type',
  'monitoring.supply.replenish.kind.tip': 'Tip',
  'monitoring.supply.replenish.kind.tc': 'TC',
  'monitoring.supply.replenish.current': 'Current remaining',
  'monitoring.supply.replenish.count': 'Remaining after refill',
  'monitoring.supply.replenish.countTips': 'Remaining after refill (total of two Tip Racks)',
  'monitoring.supply.replenish.countInvalid': 'Enter an integer from 0 to {max}',
  'monitoring.supply.replenish.note': 'Note (optional)',
  'monitoring.supply.replenish.demo': "Refill records aren't sent in mock data mode",
  'monitoring.supply.replenish.noModule': 'No Module with this Consumable was found',
  'monitoring.stage.marked': '{marked}/{total} past',
  'monitoring.stage.failures': 'Failures: {count}',
  'monitoring.stage.markedUnit': 'Samples past',
  'monitoring.stage.totalPending': 'Counting total',
  'monitoring.chamber.loaded': 'Loaded',
  'monitoring.flow.times': 'Step times',
  'monitoring.flow.timesUnavailable': 'Step times are unavailable.',
  'monitoring.flow.since': '{elapsed} since {time}',
  'monitoring.flow.elapsedMin': '{min} min',
  'monitoring.flow.elapsedHour': '{hour} h {min} min',
  'monitoring.flow.maskedSample': 'Sample ID',
  'monitoring.sampleDrawer.chambers': 'Chambers',
  'monitoring.sampleDrawer.tray': "Tray · this Sample's slots {wells}",
  'monitoring.sampleDrawer.progress': 'Progress log',
  'monitoring.sampleDrawer.dispenses': 'Dispense log',
  'panel.suggestedActions': 'Actions',
  'panel.trayLoad': 'Tray load',
  'panel.trayUnload': 'Tray unload',
  'panel.handoffPoint': 'Bay',
  'panel.openedAt': 'Opened',
  'panel.confirmedAt': 'Confirmed',
  'panel.loadedChambers': 'Loaded Chambers',
  'column.completedAt': 'Completed',
  'column.endedAt': 'Ended',
  'row.batchStartedAt': 'Task started',
  'row.batchEndedAt': 'Task ended',
  'row.pendingConfirm': 'Awaiting confirmation',
  'batchDetail.recipe.versionGone':
    "No route to fetch the body of the version this Task used (v{fixed}) — the Recipe's current version is v{current}",
  'enum.confirmSource.module_local': 'Module local',
  'enum.confirmSource.tablet': 'Tablet',
  'enum.confirmSource.client_app': 'Desktop',
  'enum.confirmSource.robot_pick': 'Robot unload',
  'enum.confirmSource.dev_auto': 'Dev auto-confirm',
  'value.awaitingConfirm': 'Awaiting confirmation',
  'action.confirmLoad': 'Confirm load',
  'action.confirmUnload': 'Confirm unload',
  'reason.alreadyConfirmed': 'Already confirmed',
  'field.loadedChambersReport': 'Loaded Chamber count',
  'value.notReported': 'Not reported',
  'value.expectedChambers': 'Expected {count}',
  'reason.loadedChambersInvalid': 'Loaded Chamber count must be an integer of 0 or more',
  'state.empty.trayLoad': 'No load records',
  'state.empty.trayUnload': 'No unload records',
  'screen.sampleReport.title': 'Sample report',
  'row.reagentLots': 'Reagent lots used',
  'row.dispenseCount': 'Dispense log',
  'screen.batchDiscard.title': 'Discard Task',
  'screen.batchConfirmCompleted.title': 'Confirm completion',
  'batch.cancel.action': 'Cancel Task',
  'batch.cancel.title': 'Cancel Task',
  'batch.cancel.body':
    "Cancels the waiting Task. Its Samples are released for reuse. This can't be undone.",
  'enum.operation.createBatch': 'Create Task',
  'enum.operation.startBatch': 'Start Task',
  'enum.operation.pauseBatch': 'Pause',
  'enum.operation.resumeBatch': 'Resume',
  'enum.operation.stopBatch': 'Stop',
  'enum.operation.recoverBatch': 'Recovery decision',
  'preflight.passed': 'Passed',
  'preflight.blocked': 'Blocked',
  'preflight.blockers': 'Blockers',
  'preflight.matrix.title': 'Pre-start checks',
  'preflight.matrix.state': 'Status',
  'preflight.matrix.fail': 'Blocked',
  'preflight.matrix.inconclusive': 'Inconclusive',
  'preflight.matrix.warning': 'Check needed',
  'preflight.matrix.count': '{count}',
  'preflight.matrix.empty': 'None',
  'preflight.matrix.missing.fail': 'Blocker details not provided',
  'preflight.matrix.missing.inconclusive': 'Inconclusive details not provided',
  'preflight.matrix.missing.warning': 'Warning details not provided',
  'preflight.group.common': 'Common',
  'preflight.group.reagents': 'Reagents',
  'preflight.group.details': 'Details',
  'preflight.group.settingPass': 'Passed by setting',
  'preflight.group.code': 'Code',
  'preflight.group.setting': 'Pass setting',
  'preflight.group.module': 'Module',
  'preflight.group.item': 'Item',
  'preflight.group.verdict': 'Verdict',
  'preflight.group.detail': 'Detail',
  'preflight.group.required': 'Action needed',
  'preflight.group.confidence': 'Confidence',
  'preflight.group.autoConfirm': 'Load auto-confirm expected',
  'preflight.issue.HANDOFF_POINT_OCCUPIED_AT_START': 'Bay occupied',
  'preflight.issue.PREFLIGHT_TRAY_NOT_LOADED': 'Tray not loaded',
  'preflight.issue.BATCH_SAMPLE_SET_UNSUPPORTED': 'Check Sample pairs',
  'preflight.issue.VISION_INSPECT_INCONCLUSIVE_AT_START': 'Vision inconclusive',
  'preflight.issue.VISION_DEVICE_FAULT_AT_START': 'Vision device fault',
  'preflight.issue.PREFLIGHT_MODULE_NOT_IDLE': 'Module not idle',
  'preflight.issue.PREFLIGHT_CONSUMABLE_UNVERIFIED': 'Consumables unverified',
  'preflight.issue.PREFLIGHT_SAFETY_STOP': 'Safety Stop',
  'preflight.issue.PREFLIGHT_GRIP_DROP_UNRECOVERED': 'Gripper drop unrecovered',
  'preflight.issue.PREFLIGHT_WASTE_NOT_EMPTIED': 'Empty the waste bin',
  'preflight.issue.PREFLIGHT_DOOR_OPEN': 'Door open',
  'preflight.issue.PREFLIGHT_BAY_OCCUPIED': 'Object in bay',
  'preflight.issue.PREFLIGHT_ITEM_MISSING': 'Required item missing',
  'preflight.issue.PREFLIGHT_COUNT_MISMATCH': 'Item count mismatch',
  'preflight.issue.PREFLIGHT_POSE_INVALID': 'Item out of position',
  'preflight.issue.PREFLIGHT_PLAN_COORD_MISMATCH': 'Plan coordinate mismatch',
  'preflight.issue.PREFLIGHT_PROCESS_UNRESOLVED': 'Recipe process not linked',
  'preflight.issue.PREFLIGHT_CHAMBER_DAMAGED': 'Chamber damaged',
  'preflight.issue.PREFLIGHT_CHAMBER_LEAKING': 'Chamber leaking',
  'preflight.issue.RECIPE_VALIDATION_FAIL': 'Recipe validation needed',
  'preflight.issue.TIP_SHORTAGE_AT_START': 'Tips short',
  'preflight.issue.TC_SHORTAGE_AT_START': 'TC short',
  'preflight.issue.REAGENT_SHORTAGE_AT_START': 'Reagent short',
  'preflight.issue.REAGENT_VOLUME_LOW': 'Reagent margin low',
  'preflight.issue.REAGENT_EXPIRED_AT_START': 'Reagent expired',
  'preflight.issue.REAGENT_TEMP_NOT_REACHED': 'Reagent temp not reached',
  'preflight.issue.POSITION_UNTAUGHT': 'Teaching needed',
  'preflight.issue.ALARM_NO_REMOTE_RECIPIENT': 'No remote recipient',
  'preflight.unresolved': 'Unresolved items',
  'preflight.warnings': 'Warnings — check before start',
  'preflight.warnAck': 'I have checked the warnings above',
  'preflight.title': 'Preflight',
  'recipe.vocab.title': 'Recipe step vocabulary — screen check',
  'recipe.vocab.retired':
    'This Recipe uses retired step names ({names}). It may stop after starting — cloning the Recipe switches to the new names',
  'recipe.vocab.unknown':
    'Some steps are not in the current vocabulary ({names}). The server decides',
  'recipe.vocab.migrated': 'Upgrading {count} retired step names to the new vocabulary',
  'reason.ackNotRequired': 'This Alarm needs no acknowledgement',
  'reason.alarmAcked': 'Already acknowledged',
  'reason.alarmUnresolved': 'Condition not resolved yet',
  'reason.alarmCleared': 'Alarm already cleared',
  'reason.noAlarmsToClear': 'No Alarms to clear',
  'reason.afterBatchCreated': 'Available after creating the Task',
  'reason.needRecipeAndSample': 'A Recipe and Samples are required',
  'reason.batchAlreadyCreated': 'Task already created',
  'reason.requestInFlight': 'Sending',
  'reason.demoSource': "Can't send from mock data",
  'reason.confirmSurfaceUnknown': "Can't confirm: this screen has no confirmation surface assigned",
  'pfFix.open': 'Fix issues',
  'pfFix.confirmUnload': 'Confirm unload',
  'pfFix.confirmLoad': 'Load done',
  'pfFix.loadsLoading': 'Loading the load list',
  'pfFix.loadsFailed': "Couldn't read the load list — reload with [Re-run Preflight]",
  'pfFix.unloadsLoading': 'Loading the unload list',
  'pfFix.unloadsFailed': "Couldn't read the unload list — reload with [Re-run Preflight]",
  'pfFix.loadMissing':
    'No loads are pending. Check unloading and Module connection, then press [Re-run Preflight].',
  'pfFix.prepare': 'Clear bay',
  'pfFix.batchPreservingOnly':
    "Full preparation that stops the Task isn't available in the start check. Use the per-item fixes.",
  'pfFix.handoffPhysicalCheck': 'I removed the Tray from this bay and confirmed it is empty',
  'pfFix.handoffPointMissing': "The server didn't provide a bay ID, so it can't be cleared",
  'batchHistory.incomplete': 'Not all Sample assignment records from that time can be verified.',
  'batchHistory.currentMissing': "The current status of some Samples can't be verified.",
  'pfFix.replaceWaste': 'Log waste bin change',
  'pfFix.supply.tip': 'Refill tips',
  'pfFix.supply.tc': 'Refill TC',
  'pfFix.supply.reagent': 'Refill reagent',
  'pfFix.supply.noCapacity':
    "Couldn't read slot counts from this Task's Recipe — can't set the refill amount",
  'pfFix.installLabware': 'Install definition',
  'pfFix.lbw.title': 'Install definition — {position}',
  'pfFix.lbw.module': 'Module',
  'pfFix.lbw.wantedRow': 'Definition the check wants',
  'pfFix.lbw.installed': 'Installed now',
  'pfFix.lbw.templates': 'Labware Templates',
  'pfFix.lbw.none': 'None',
  'pfFix.lbw.new': 'New',
  'pfFix.lbw.add': 'Select',
  'pfFix.lbw.remove': 'Remove',
  'pfFix.lbw.keep': 'Undo',
  'pfFix.lbw.wanted': '· wanted by the check',
  'pfFix.lbw.alreadyListed': 'Already listed',
  'pfFix.lbw.noTemplates': 'The server has no Labware Templates to choose from',
  'pfFix.lbw.noPosition': "This bay isn't in the Module's location list",
  'pfFix.lbw.offsets': 'Dispense offsets (mm)',
  'pfFix.lbw.well': 'Well',
  'pfFix.lbw.badNumber': "Some fields aren't numbers — {wells}",
  'pfFix.lbw.noChange': 'No changes',
  'pfFix.lbw.offsetRule':
    'Bays with an untaught origin need dispense offsets before Preflight accepts this definition. Leave the fields empty to install without offsets',
  'pfFix.lbw.partialOffsets': 'Only some offset fields are filled — fill all or none: {uris}',
  'pfFix.lbw.send': 'Save definition',
  'pfFix.recheck': 'Re-run Preflight',
  'pfFix.running': '{action} in progress…',
  'pfFix.done': '{action} — received · re-checking',
  'pfFix.failed': '{action} — {reason}',
  'pfFix.moduleUnknown': 'Module status not received yet',
  'pfFix.passed': 'Preflight passed — close this and press [Start] again',
  'pfAll.action': 'Prepare all',
  'pfAll.recreate.running': 'Recreating with the same Recipe · Samples · wells…',
  'pfAll.recreate.notWaiting': "Only a Task that hasn't started can be recreated (now {status})",
  'pfAll.recreate.noAssignments':
    "This Task has no well assignments, so it can't be recreated as is",
  'pfAll.recreate.unplaced':
    "Only {placed} of {count} Samples have a well, so it can't be recreated as is",
  'pfAll.recreate.recipeNotCommitted':
    "The Recipe isn't committed right now ({status}), so it can't be recreated — nothing was changed",
  'pfAll.recreate.versionChanged':
    'The Recipe version changed (this Task v{was} → now v{now}). Recreating would make a different Task, so nothing was changed',
  'pfAll.recreate.createdOtherVersion':
    'New Task {batch} was created with a different Recipe version (v{was} → v{now}) — check it before starting',
  'pfHeld.action': 'Stop Task and place Tray',
  'pfHeld.button': 'Stop and place',
  'pfHeld.notice':
    'This stops the Task, places the Tray held by the Transfer Robot in an empty bay chosen by the server, then recreates the Task with the same Recipe · Samples · wells. The Task is recreated even if placing fails.',
  'pfHeld.physicalCheck': 'I checked the robot arm area and the held Tray on site',
  'pfHeld.status.stopping': 'Stopping Task {batch}…',
  'pfHeld.status.placing': 'Placing the held Tray at {point}…',
  'pfHeld.status.settling': 'Waiting for the Transfer Robot to return to idle…',
  'pfHeld.placeRefused': "Can't place the Tray — {reason}",
  'pfHeld.noTarget': 'No empty bay to place the Tray',
  'pfHeld.placeTimeout': "Placing didn't finish within {seconds} s — {said}",
  'pfHeld.placeHalted': 'Placing halted ({status}) — {said}',
  'pfHeld.robotNotIdle': "The Transfer Robot didn't return to idle after placing (now {state})",
  'pfHeld.handoffReason': 'Stop Task and place · confirmed bay {point} empty (no ledger record)',
  'pfHeld.done': 'Recreated as is — new Task {batch}',
  'pfHeld.donePlaceFailed':
    "New Task {batch} was created, but the Tray couldn't be placed — {reason}",
  'pfHeld.failedStopped': "This Task was stopped but couldn't be recreated — {reason}",
  'stopsRelease.check.robot_area': 'I checked the held Tray and the robot arm area in person',
  'stopsRelease.check.tray_positions': 'I checked the actual Tray position at each handoff bay',
  'stopsRelease.check.door_area': 'No people or hands are near the open door; it is safe to close',
  'stopsRelease.check.rotor_balanced':
    'Centrifuge loading is balanced and Chamber positions are unchanged',
  'stopsRelease.title': 'Current system stops',
  'stopsRelease.count': 'Active stops: {count} · system-wide list',
  'stopsRelease.children': 'Sub-stops: {count} ({targets}) — released with the stop above',
  'stopsRelease.safety.line': '{head} — {cause}',
  'stopsRelease.safety.estop': 'E-STOP',
  'stopsRelease.safety.stop': 'Safety Stop',
  'stopsRelease.safety.cause.operator': 'Pressed with the on-screen E-STOP button',
  'stopsRelease.safety.cause.hw': '{module} Emergency Stop button',
  'stopsRelease.safety.cause.fault': '{module} fault ({code})',
  'stopsRelease.safety.cause.faultNoCode': '{module} fault',
  'stopsRelease.safety.cause.unknown': 'Unknown cause',
  'stopsRelease.global': 'System-wide list · includes stops from other Tasks',
  'stopsRelease.empty': 'No current system stops',
  'stopsRelease.action': 'On-site check & release',
  'stopsRelease.confirm': 'Release all checked',
  'stopsRelease.changed': 'The stop list changed. Review the list and redo the on-site check.',
  'stopsRelease.physical': 'The server requires these on-site checks',
  'stopsRelease.unknownCheck': "A new on-site check item exists, so stops can't be released",
  'stopsRelease.pending': 'Waiting for the release response',
  'stopsRelease.result': 'Release result',
  'stopsRelease.done': 'Processed',
  'stopsRelease.failed': 'Not processed',
  'stopsRelease.moduleNow': '{module} now: {state}',
  'stopsRelease.moduleExecution': '{sequence} ({step}/{total})',
  'stopsRelease.after':
    'Check Equipment status in the latest stop list. Resume with [Resume] on the Task Bar.',
  'stopsRelease.humanFirst': 'On-site check needed',
  'stopsRelease.included': 'Released with parent stop',
  'stopsRelease.reconfirm': 'Re-check',
  'stopsRelease.recover.action': 'Close door & home',
  'stopsRelease.recover.confirmBody':
    "{module} is stopped by a cancel, so it didn't accept the door close from the stop release. This sends door close directly, then sends homing (initialize) once the door is closed. Afterwards, release the stop again with [On-site check & release].",
  'stopsRelease.recover.check': 'I confirmed no people, hands or objects are near the door',
  'stopsRelease.recover.step.closeDoor': 'Close door',
  'stopsRelease.recover.step.waitDoor': 'Verify door closed',
  'stopsRelease.recover.step.initialize': 'Homing',
  'stopsRelease.recover.running': '{step} in progress',
  'stopsRelease.recover.failed': 'Stopped at {step} — {message}',
  'stopsRelease.recover.doorTimeout': 'No door-closed reading arrived in time',
  'stopsRelease.recover.done':
    'Door closed and homing sent. Stop list reloaded — release any remaining stops with [On-site check & release].',
  'pfStops.action': 'Release stops',
  'pfStops.loading': 'Loading active stops',
  'pfStops.none': 'Nothing to release',
  'pfStops.releasable': 'Releases the items below at once (open doors will close)',
  'pfStops.notDone': "Some items weren't released — {items}",
  'pfStops.stillListed': 'Still listed after {seconds} s — {items}',
  'reason.warnAckRequired': 'Check the warnings before starting',
  'state.empty.reports': 'No reports',
  'state.empty.envRunning': 'None',
  'state.empty.pickedSamples': 'No Samples picked',
  'state.empty.freeSamples': 'No Samples available',
  'state.empty.committedRecipes': 'No committed Recipes',
  'state.empty.blockers': 'No blockers',
  'state.empty.warnings': 'No warnings',
  'state.empty.preflightNotRun': 'Not checked yet',
  'enum.ledger.audit': 'Audit',
  'enum.ledger.ops': 'Operations',
  'enum.ledger.consumable': 'Consumables',
  'mask.pii': '••••',
  'mask.none': '—',
  'error.unknown': "Couldn't process this",
  'error.network': "Couldn't connect to the server",
  'error.http401': 'Login required',
  'error.http403': 'No permission',
  'error.http404': 'Item not found or deleted',
  'error.NOT_FOUND': 'Item not found or deleted',
  'error.http500': "The server couldn't process the request",
  'error.http502': "Couldn't connect to the server",
  'error.http503': "The server can't respond right now",
  'error.http504': 'The server response was too slow and timed out',
  'error.INSUFFICIENT_ROLE': 'No permission',
  'error.CONTROL_LOCK_HELD':
    'Another user is in control — wait for release or ask an admin to release it',
  'error.HANDOFF_RESOURCE_IN_USE':
    'Another handoff is using that robot or bay — if quarantined, check it physically, then free it with [Release]',
  'error.STOPS_CHANGED': 'The list changed — check it again',
  'error.MODULE_DELETE_REJECTED':
    "Can't delete this Module row — check its service end state, open Tasks and executions",
  'error.BATCH_COMMAND_NOT_ALLOWED': "This command can't be accepted in the current state",
  'error.SAFETY_NOT_CLEARED':
    "Clear safety refused — physical safety conditions aren't resolved yet",
  'error.E_STOP': 'Emergency Stop triggered',
  'error.AUTH_FAILED': 'Authentication failed — check your account and password',
  'error.ACCOUNT_LOCKED': "This account can't log in right now — contact an admin",
  'error.CURRENT_PASSWORD_MISMATCH': "The current password doesn't match",
  'error.WEAK_PASSWORD': "The password doesn't meet the policy",
  'error.REQUEST_VALIDATION_FAIL': "The input isn't valid",
  'error.RECIPE_VALIDATION_FAIL': "Recipe values aren't valid (range, order, time)",
  'error.PREFLIGHT_BLOCK': "Preflight didn't pass",
  'error.SAMPLE_ALREADY_EXISTS': 'This Sample ID is already registered — use another ID',
  'error.MODULE_DRIVER_NOT_WIRED':
    'No driver is connected to this Equipment — tell the service contact',
  'error.CENT_IMBALANCE': 'The Centrifuge rotor is out of balance',
  'error.COMM_TIMEOUT': 'Communication timed out',
  'error.ASM_TC_ALIGN_FAIL': 'TC alignment failed — not seated correctly in the receiver',
  'error.DISPENSE_CLOG': 'Dispenser clogged',
  'error.STAIN_SHAKE_FAIL': 'Shaker below target speed · stopped',
  'column.stage': 'Stage',
  'row.currentModule': 'Current Module',
  'row.position': 'Location',
  'row.discardReason': 'Discard reason',
  'column.registeredAt': 'Registered at',
  'row.currentPosition': 'Current bay',
  'row.assignedWell': 'Assigned well',
  'row.assignedWell.server': 'Server assigned {well}',
  'row.sampleRef': 'Group',
  'card.placement': 'Bay',
  'card.location': 'Location',
  'filter.search.samples': 'Search Sample ID · Patient ID',
  'action.addSample': '＋ Add Sample',
  'action.correct': 'Correct',
  'action.saveCorrection': 'Save correction',
  'action.report': 'Report',
  'card.sample': 'Sample',
  'card.testInfo': 'Test info',
  'card.correctionReason': 'Correction reason',
  'card.operation': 'Operation',
  'field.sampleType': 'Type',
  'field.rbc': 'RBC concentration',
  'field.drawDate': 'Draw date',
  'field.cancerType': 'Cancer type',
  'field.cancerStage': 'Cancer stage',
  'field.drawAt': 'Draw date & time',
  'dateTime.placeholder': 'Select date · time',
  'dateTime.prevMonth': 'Previous month',
  'dateTime.nextMonth': 'Next month',
  'dateTime.monthTitle': '{year}-{month}',
  'dateTime.weekdays': 'Sun,Mon,Tue,Wed,Thu,Fri,Sat',
  'dateTime.hour': 'Hour',
  'dateTime.minute': 'Min',
  'dateTime.noTime': 'No time',
  'dateTime.cancel': 'Cancel',
  'dateTime.confirm': 'Confirm',
  'field.drawTime': 'Draw time',
  'field.sampleExtras': 'Extra fields',
  'field.reason': 'Reason',
  'field.alarmNote': 'Note',
  'sec.sample.input': 'Sample info',
  'sec.sample.rows': 'Sample list',
  'sampleNew.list.empty': 'Add Samples',
  'sampleNew.list.add': '＋ Add Sample',
  'value.na': 'NA',
  'reason.nothingChanged': 'No fields changed',
  'reason.maskedValue': "Masked values can't be corrected",
  'reason.sampleIdRequired': 'Sample ID required',
  'sampleNew.existing.checking': 'Checking registered IDs',
  'sampleNew.existing.unread':
    "Couldn't read registered Samples, so existing IDs and suggestions weren't checked — {reason}",
  'sampleNew.drawDate.future': 'This date is after today',
  'sampleNew.drawAt.format': 'Use YYYY-MM-DD or YYYY-MM-DD HH:MM',
  'sampleNew.drawTime.placeholder': 'HH:MM',
  'sampleNew.drawTime.format': 'Use HH:MM (24-hour) for the time',
  'sampleNew.drawTime.noDate': 'Time entered without a date',
  'sampleNew.extras.add': '+ Add extra field',
  'sampleNew.extras.keyLabel': 'Field {n} name',
  'sampleNew.extras.keyPlaceholder': 'Name',
  'sampleNew.extras.valueLabel': '{name} value',
  'sampleNew.extras.valuePlaceholder': 'Value',
  'sampleNew.extras.remove': 'Remove {name}',
  'sampleNew.extras.noKey': 'A value has no name',
  'sampleNew.extras.noValue': 'An item has no value — enter one or remove it',
  'sampleNew.extras.dupKey': 'The name “{key}” appears twice',
  'sampleNew.extras.reserved': '“{key}” is a name used by this screen',
  'sampleNew.form.inList': 'This ID is already in the added Samples',
  'sampleNew.list.removeRow': 'Remove {name}',
  'sampleNew.list.removed': 'Removed “{id}”',
  'sampleNew.list.undo': 'Undo',
  'sampleNew.paste.added': 'Rows added: {count}',
  'sampleNew.submit': 'Add {count}',
  'sample.status.available': 'Available',
  'sampleNew.reregister': 'Re-register for testing',
  'sampleNew.reregister.done': 'Re-registered as {id}',
  'sampleNew.confirm': 'Confirm',
  'sampleNew.col.result': 'Result',
  'sampleNew.col.actions': 'Actions',
  'sampleNew.row.label': 'Row {n}',
  'sampleNew.cell.dupInForm': 'Duplicate in list',
  'sampleNew.hints.open': '{field} suggestions',
  'sampleNew.hints.remove': 'Remove {value} from list',
  'sampleNew.create.empty': '+ Enter manually',
  'sampleNew.create.typed': '+ Enter “{value}” manually',
  'sampleNew.row.ok': 'Registered',
  'sampleNew.row.metadataUnseen': 'metadata not in response',
  'sampleNew.row.duplicate': 'Duplicate ID',
  'sampleNew.row.exists': 'This Sample ID is already registered',
  'reason.registering': 'Registering',
  'reason.noSampleRows': 'No Samples added',
  'reason.sampleRegistered': 'Registered',
  'reason.sampleListErrors': 'Added Samples have rows to check',
  'enum.sampleStage.registered': 'Registered',
  'enum.sampleStage.centrifuged': 'Centrifuge',
  'enum.sampleStage.assembled': 'Assembly',
  'enum.sampleStage.staining': 'Staining',
  'stageCard.cent': 'Centrifuge',
  'stageCard.asm': 'Assembler',
  'stageCard.stain': 'Staining',
  'enum.sampleStage.completed': 'Completed',
  'action.newRecipe': '＋ Add Recipe',
  'recipeNewStandard.changed': 'Edited: {count}',
  'recipeNewStandard.badField': 'Enter a value — number fields take integers of 0 or more',
  'recipeNewStandard.reagents': 'Reagents',
  'recipeNewStandard.labware': 'Labware',
  'recipeNewStandard.reagentsEmpty': 'This Recipe has no reagents',
  'recipeStd.col.no': '#',
  'recipeStd.col.sequenceParams': 'Sequence values',
  'recipeStd.col.shake': 'Shaking',
  'recipeStd.col.reagentNo': 'No.',
  'recipeStd.col.description': 'Description',
  'recipeStd.col.labwareId': 'Labware ID',
  'recipeStd.col.definitionUri': 'Definition',
  'recipeStd.col.tipTypeIndex': 'Tip type no.',
  'recipeStd.col.pickOrder': 'Pick order',
  'recipeStd.col.metadataExt': 'Extra info',
  'recipeNewStandard.regenerateFailed':
    "Couldn't rebuild commands from the edited values — {reason}",
  'recipeStandard.loading': 'Loading standard Recipe',
  'recipeV2.format': 'Format',
  'recipeV2.formatValue': 'Opentrons protocol/{version}',
  'recipeV2.protocolName': 'Document name',
  'recipeV2.commands': 'Commands',
  'recipeV2.labwareDefinitions': 'Labware definitions',
  'recipeV2.liquids': 'Liquids',
  'recipeV2.commandsCell': 'Commands: {count}',
  'reason.v2NoCommands': 'New-format document has no commands',
  'recipeV2.note':
    'New-format (Opentrons protocol) Recipe — section, step and reagent tabs are legacy-only, so only a summary is shown here',
  'screen.templates.title': 'Templates',
  'tab.template.recipe': 'Recipes',
  'action.recipeFromTemplate': 'Create Recipe from Template',
  'recipeTemplate.samples': 'Sample slots',
  'recipeTemplate.commands': 'Commands',
  'recipeTemplate.stageList': 'Step order',
  'recipeTemplate.col.stage': 'Step',
  'recipeTemplate.col.work': 'Operation',
  'recipeTemplate.shape.fill': 'Fill',
  'recipeTemplate.shape.fill_shake': 'Fill · shake',
  'recipeTemplate.shape.exchange': 'Exchange',
  'recipeTemplate.shape.exchange_shake': 'Exchange · shake',
  'recipeTemplate.col.sampleRef': 'Slot',
  'state.empty.templates': 'No Templates',
  'filter.search.templates': 'Search name · ID',
  'template.field.shape': 'Shape',
  'template.field.reagent_role': 'Reagent role',
  'tplTable.location': 'Slot',
  'tplTable.place.chilled': 'Chilled',
  'tplTable.labware': 'Labware',
  'tplTable.labwareId': 'Bay',
  'tplTable.reagent': 'Reagent',
  'tplTable.wellsVolume': 'Wells · volume',
  'action.create': 'Create',
  'action.makeBatchFrom': 'Create Task from this Recipe',
  'action.readJson': 'Read',
  'action.pickFile': 'Choose file',
  'action.addChannel': '＋ Add channel',
  'action.removeChannel': 'Remove channel',
  'sort.label': 'Sort',
  'card.basicInfo': 'Basic info',
  'card.method': 'Creation method',
  'card.recipePreview': 'Recipe preview',
  'card.baseRecipe': 'Base Recipe',
  'card.payloadJson': 'Payload JSON',
  'card.summary': 'Summary',
  'card.history': 'History',
  'method.form': 'Set values directly',
  'method.clone': 'Clone existing Recipe',
  'method.json': 'Import JSON',
  'field.name': 'Name',
  'row.schemaVersion': 'Schema',
  'row.sections': 'Sections',
  'row.steps': 'Steps',
  'row.reagents': 'Reagents',
  'row.chambers': 'Chambers',
  'row.batchInputs': 'Task inputs',
  'row.method': 'Method',
  'section.centrifuge': 'Centrifuge',
  'section.assembler': 'Assembly',
  'section.staining': 'Staining',
  'section.trayPath': 'Tray layout',
  'section.common': 'Common',
  'field.speed': 'Spin speed',
  'field.spinDuration': 'Spin time',
  'field.rounds': 'Runs',
  'field.uvDuration': 'UV time',
  'field.uvAngle': 'UV angle',
  'field.loadTilt': 'Load tilt',
  'field.drainTilt': 'Drain tilt',
  'field.tipChange': 'Tip change',
  'field.patientCount': 'Patients',
  'field.chambersPerPatient': 'Chambers per patient',
  'field.referenceWell': 'Reference well',
  'field.recoveryDelay': 'Max recovery delay',
  'field.storageTemp': 'Storage temp',
  'column.component': 'Component',
  'column.lot': 'Lot',
  'value.perBatchInput': 'Entered at Task creation',
  'column.mandatory': 'Required',
  'column.bindsTo': 'Binds to',
  'column.base': 'Base',
  'column.otherValues': 'Other values',
  'column.totalVolume': 'Volume (µL)',
  'column.sequence': 'Sequence',
  'column.note': 'Note',
  'column.alarmCondition': 'Condition',
  'column.tipPolicy': 'Tip policy',
  'column.liquidClass': 'Liquid class',
  'column.toWaste': 'To waste',
  'column.wasteStream': 'Waste stream',
  'column.shake': 'Shaking',
  'value.yes': 'Yes',
  'value.no': 'No',
  'card.runtimeParameters': 'Task inputs',
  'card.recipeLabware': 'Recipe Labware',
  'card.liquidClasses': 'Liquid classes',
  'state.empty.runtimeParameters': 'This Recipe has no Task inputs',
  'state.empty.recipeLabware': 'This Recipe has no Labware',
  'state.empty.liquidClasses': 'This Recipe has no liquid classes',
  'state.empty.recipeSteps': 'This section has no steps',
  'reason.reagentChannelsFull': 'All 8 reagent channels in use',
  'state.empty.recipeList': 'No Recipes',
  'screen.recipeArchive.title': 'Archive Recipe',
  'reason.committedOnly': 'Committed Recipes only',
  'reason.draftOnly': 'Drafts only',
  'reason.recipeAlreadyArchived': 'Recipe already archived',
  'reason.archivedNoBatch': "Can't create a Task from an archived Recipe",
  'reason.draftNoBatch': "Can't create a Task from an uncommitted Recipe",
  'notice.recipeReadOnly': "Read-only — committed Recipes can't be edited",
  'error.recipeJsonInvalid': 'Not valid JSON',
  'error.recipeJsonNotObject': "The body isn't an object",
  'error.recipeJsonMissingSections': 'Required sections missing — {sections}',
  'error.fileReadFailed': "Couldn't read the file",
  'recipeEdit.card.template': 'Starting Recipe',
  'recipeEdit.template.label': 'Starting Recipe',
  'recipeEdit.template.toggle': 'Open starting Recipe list',
  'recipeEdit.action.load': 'Load',
  'recipeEdit.action.clear': 'Clear',
  'recipeEdit.action.defaults': 'Defaults',
  'recipeEdit.template.none': 'Select a Recipe to load',
  'recipeEdit.extraKeys': 'Fields not in schema: {count} — the server will reject this as is',
  'recipeEdit.optional': 'Optional',
  'recipeEdit.groups': 'Recipe sections',
  'recipeEdit.filled': 'Filled: {count}',
  'recipeEdit.empty': 'Empty',
  'recipeEdit.jsonFilled': 'Filled · lines: {lines}',
  'recipeEdit.jsonGroup': 'JSON section',
  'recipeEdit.issueMark': 'To fix: {count}',
  'recipeEdit.noStepsYet': 'No steps',
  'recipeEdit.steps': 'Steps',
  'recipeEdit.moduleSteps': 'Module steps',
  'recipeEdit.stepN': 'Step {n}',
  'recipeEdit.action.addStep': '＋ Add step',
  'recipeEdit.action.removeStep': 'Delete',
  'recipeEdit.action.moveUp': 'Up',
  'recipeEdit.action.moveDown': 'Down',
  'recipeEdit.action.expand': 'Expand',
  'recipeEdit.action.collapse': 'Collapse',
  'recipeEdit.reason.firstStep': 'Top step',
  'recipeEdit.reason.lastStep': 'Bottom step',
  'recipeEdit.card.otherSections': 'Other sections',
  'recipeEdit.json.reagents': 'Reagents (JSON)',
  'recipeEdit.json.labware': 'Labware (JSON)',
  'recipeEdit.json.trayPath': 'Tray layout (JSON)',
  'recipeEdit.json.liquidClasses': 'Liquid classes (JSON)',
  'recipeEdit.json.runtimeParameters': 'Task inputs (JSON)',
  'recipeEdit.card.issues': 'Fix before creating',
  'recipeEdit.issuesMore': '+{count} more',
  'recipeEdit.issue.required': '{where} — enter a value',
  'recipeEdit.issue.number': '{where} — not a number',
  'recipeEdit.issue.integer': '{where} — must be an integer',
  'recipeEdit.issue.min': '{where} — must be {min} or more',
  'recipeEdit.issue.max': '{where} — must be {max} or less',
  'recipeEdit.issue.option': '{where} — must be a value in the list',
  'recipeEdit.issue.retired': '{where} — retired name. Use {to}',
  'recipeEdit.issue.duplicate': '{where} — the same value appears twice',
  'recipeEdit.issue.json': '{where} — not valid JSON',
  'recipeEdit.issue.shapeObject': '{where} — must be an object ({ })',
  'recipeEdit.issue.shapeArray': '{where} — must be an array ([ ])',
  'recipeEdit.issue.noSteps': '{where} — needs at least one step',
  'recipeEdit.issue.location': '{where} — enter a bay type or a Point',
  'recipeEdit.card.violations': 'Server rejection reasons: {count}',
  'recipeEdit.violationsMore': '+{count} more',
  'recipeEdit.bool.label': 'Select {field}',
  'recipeEdit.options.toggle': 'Open {field} list',
  'recipeEdit.f.speedRpm': 'Spin speed (rpm)',
  'recipeEdit.f.durationSec': 'Spin time (s)',
  'recipeEdit.f.temperature': 'Temperature (℃)',
  'recipeEdit.f.uvDurationSec': 'UV time (s)',
  'recipeEdit.f.uvIntensity': 'UV intensity',
  'recipeEdit.f.uvTilt': 'UV angle (°)',
  'recipeEdit.f.loadTilt': 'Load tilt (°)',
  'recipeEdit.f.drainAngle': 'Drain tilt (°)',
  'recipeEdit.f.zDescend': 'Z descent speed (%)',
  'recipeEdit.f.zHold': 'Z hold time (s)',
  'recipeEdit.f.defaultTip': 'Default tip policy',
  'recipeEdit.f.defaultLiquid': 'Default liquid class',
  'recipeEdit.f.storageTemp': 'Reagent storage temp (℃)',
  'recipeEdit.f.maxDelay': 'Max recovery delay (s)',
  'recipeEdit.f.stepId': 'Step ID',
  'recipeEdit.f.sequence': 'Sequence',
  'recipeEdit.f.round': 'Run',
  'recipeEdit.f.chambers': 'Chambers',
  'recipeEdit.f.payloadKind': 'Payload',
  'recipeEdit.f.source': 'Source bay',
  'recipeEdit.f.target': 'Target bay',
  'recipeEdit.f.sourceKind': 'Source bay type',
  'recipeEdit.f.sourceSlot': 'Source slot',
  'recipeEdit.f.sourcePoint': 'Source Point',
  'recipeEdit.f.sourceWaste': 'Source waste bin',
  'recipeEdit.f.targetKind': 'Target bay type',
  'recipeEdit.f.targetSlot': 'Target slot',
  'recipeEdit.f.targetPoint': 'Target Point',
  'recipeEdit.f.targetWaste': 'Target waste bin',
  'recipeEdit.f.pointId': 'Point',
  'recipeEdit.f.bodyPosition': 'Process reference location',
  'recipeEdit.f.note': 'Note',
  'recipeEdit.f.params': 'Parameters (JSON)',
  'recipeEdit.f.operation': 'Operation',
  'recipeEdit.f.targetWells': 'Target wells',
  'recipeEdit.f.reagentChannel': 'Reagent channel',
  'recipeEdit.f.volumeUl': 'Volume (µL)',
  'recipeEdit.defaultLiquidCell': '{name} (default)',
  'recipeEdit.f.deadVolumeUl': 'Dead volume (µL)',
  'recipeEdit.f.waitSec': 'Wait (s)',
  'recipeEdit.f.shakeRpm': 'Shaking speed (rpm)',
  'recipeEdit.f.shakeSec': 'Shaking time (s)',
  'recipeEdit.f.mixRepetitions': 'Mix repeats',
  'recipeEdit.f.mixVolume': 'Mix volume (µL)',
  'recipeEdit.f.repetitions': 'Repeats',
  'recipeEdit.f.tipPolicy': 'Tip policy',
  'recipeEdit.f.liquidClass': 'Liquid class',
  'recipeEdit.f.flowRate': 'Flow rate (µL/s)',
  'recipeEdit.f.toWaste': 'Send to waste',
  'recipeEdit.f.wasteStream': 'Waste stream',
  'recipeEdit.f.touchTip': 'Touch tip',
  'recipeEdit.f.airGap': 'Air gap (µL)',
  'recipeEdit.f.pushOut': 'Push out (µL)',
  'recipeEdit.f.maxStepSec': 'Step time limit (s)',
  'action.archive': 'Archive',
  'action.restore': 'Restore',
  'card.usedByRecipes': 'Used in Recipes',
  'field.layoutDetail': 'Detail level',
  'field.grid': 'Grid',
  'field.defaultVolume': 'Default volume',
  'field.tipLength': 'Tip length',
  'field.dimensions': 'Dimensions',
  'field.cornerOffset': 'Corner offset',
  'label.defId': 'Definition ID',
  'reason.noServerRoute': 'Not accepted by the server yet',
  'reason.pickedAbove': 'Select above',
  'location.staining_tray': 'Stainer · Tray bay',
  'location.staining_reagent_bay_ambient': 'Stainer · ambient reagent bay',
  'location.staining_reagent_bay_chilled': 'Stainer · chilled reagent bay',
  'location.staining_tip_bay_1': 'Stainer · Tip Rack 1',
  'location.staining_tip_bay_2': 'Stainer · Tip Rack 2',
  'location.centrifuge_tray': 'Centrifuge · Tray bay',
  'location.assembler_tray': 'Assembler · Tray bay',
  'location.assembler_tc_rack': 'Assembler · TC Rack',
  'module.connected': 'Connected',
  'module.eStopEngaged': 'E-STOP engaged',
  'card.moduleControl': 'Control',
  'action.initializeModule': 'Initialize',
  'moduleInit.confirmTitle': 'Initialize Module',
  'moduleInit.confirmBody':
    'Initializes {module}. Any execution in progress is interrupted and it returns to home.',
  'moduleInit.advisory':
    "The Module sent no allowed commands — leaving it to the server's decision",
  'moduleInit.accepted':
    'The Module accepted the initialize request — status follows via live updates',
  'moduleInit.occupied': 'Occupied bays',
  'moduleCtl.desc.initialize': 'Returns the Module to home',
  'moduleCtl.desc.forgetGrips': 'Clears only the «holding» record · moving parts stay put',
  'moduleCtl.desc.resetRecovery': 'Manually clears the auto-recovery lock',
  'moduleCtl.desc.diagnostics': 'Checks safety and material positions',
  'moduleCtl.desc.clearHandoff': 'Returns to a state that can start a Task',
  'moduleCtl.results': 'Recent results',
  'action.forgetGrips': 'Forget grips',
  'action.resetRecoveryLock': 'Clear recovery lock',
  'moduleCtl.forgetGrips.confirmBody':
    "Clears only {module}'s «holding» record. Moving parts don't move — do this only after visually confirming the gripper is empty.",
  'moduleCtl.resetRecovery.confirmBody':
    "Clears {module}'s auto-recovery lock. Do this only after checking what caused the lock.",
  'moduleCtl.done': 'Received — status follows via live updates',
  'moduleCtl.diagPassed': 'Diagnostics passed',
  'moduleCtl.diagFailed': 'Diagnostics failed',
  'enum.diagnostic.skipped': 'N/A',
  'enum.diagnostic.unknown': 'Inconclusive',
  'enum.doorState.open': 'Open',
  'enum.doorState.closed': 'Closed',
  'enum.doorDrive.opening': 'Opening',
  'enum.doorDrive.open': 'Open',
  'enum.doorDrive.closing': 'Closing',
  'enum.doorDrive.closed': 'Closed',
  'enum.doorDrive.fault': 'Drive fault',
  'reason.moduleLocalMode': "Local mode — controlled from the Module's local screen",
  'card.connection': 'Connection',
  'row.model': 'Model',
  'row.fwVersion': 'Firmware',
  'value.notPublished': 'No value',
  'enum.shakerLatch.opening': 'Opening',
  'enum.shakerLatch.idle_open': 'Open',
  'enum.shakerLatch.closing': 'Closing',
  'enum.shakerLatch.idle_closed': 'Closed',
  'enum.shakerLatch.idle_unknown': 'Idle · open/closed unknown',
  'enum.shakerLatch.unknown': 'Unknown',
  'card.recentDiagnostics': 'Recent diagnostics',
  'card.connectionHistory': 'Connection history',
  'row.lastSeen': 'Last response',
  'row.discovered': 'Discovered',
  'row.uptime': 'Uptime',
  'column.date': 'Date',
  'column.event2': 'Event',
  'label.calibrationExpiring': 'Expiring soon',
  'label.nextDue': 'Next {date}',
  'state.empty.calibrations': 'No Calibration items',
  'action.recordCalibration': '＋ Log Calibration',
  'screen.calibrationRecord.title': 'Add Calibration record',
  'field.calibrationType': 'Calibration type',
  'field.performedAt': 'Performed at',
  'field.expiresAt': 'Expires',
  'value.noVerdict': 'No verdict',
  'reason.calibrationTypeRequired': 'Calibration type required',
  'reason.performedAtRequired': 'Performed time required',
  'reason.performedAtFuture': 'Performed time is in the future',
  'reason.expiresAtInvalid': "Can't read the expiry date",
  'state.empty.diagnostics': 'No diagnostics records',
  'state.empty.logs': 'No records',
  'reason.diagnosticsNoRoute': 'No route to run diagnostics',
  'enum.diagnostic.pending': 'Waiting',
  'enum.diagnostic.running': 'Checking',
  'enum.diagnostic.pass': 'Pass',
  'enum.diagnostic.fail': 'Fail',
  'diag.comm_latency': 'Comm · latency',
  'diag.power_interlock': 'Power · interlock',
  'diag.door_sensor': 'Door sensor',
  'diag.axis_homing': 'Axis homing',
  'diag.drive_torque': 'Drive torque',
  'diag.temperature_sensor': 'Temperature sensor',
  'diag.vision_camera': 'Vision camera',
  'diag.driver_revision': 'Driver revision',
  'field.ipAddress': 'IP address',
  'enum.historyType.audit': 'Audit',
  'enum.historyType.command': 'Command',
  'enum.historyType.event': 'Event',
  'enum.historyType.batch_record': 'Task record',
  'enum.auditAction.safety_stop': 'Safety Stop',
  'enum.auditAction.ack': 'Alarm acknowledged',
  'enum.auditAction.start_warn_ack': 'Started after warning check',
  'enum.auditAction.recipe_edit': 'Recipe edited',
  'enum.auditAction.role_change': 'Role changed',
  'enum.auditAction.user_create': 'Account created',
  'enum.auditAction.chain_verify': 'Ledger verified',
  'action.addUser': '＋ Add user',
  'action.changeRole': 'Change role',
  'action.resetPassword': 'Reset password',
  'action.lock': 'Lock',
  'action.unlock': 'Unlock',
  'action.deactivate': 'Deactivate',
  'card.accountSettings': 'Account settings',
  'row.accountStatus': 'Account status',
  'action.reset': 'Reset',
  'action.activate': 'Activate',
  'reason.noReactivateRoute': 'No route to reactivate',
  'reason.selfDeactivate': "Can't deactivate your own account",
  'reason.selfLock': "Can't lock your own account",
  'reason.selfPassword': 'Change yours in Settings',
  'reason.selfSession': "Can't end this device's session",
  'reason.actionInFlight': 'Requesting',
  'row.reversible': 'Reversible',
  'value.irreversible': 'No',
  'action.endSession': 'Force end',
  'action.endOtherSessions': 'End all other sessions',
  'action.openAuditLog': 'Open Logs › Audit →',
  'setting.section.ops': 'Operations',
  'setting.section.actions': 'System actions',
  'setting.mode': 'Operating mode',
  'setting.prepareModules': 'Force-clear Task preparation',
  'action.prepareModules': 'Run cleanup',
  'prepare.residualRisk':
    "Halted Tasks will be discarded. Running Tasks and waiting Tasks that haven't started will also be closed. Closed Tasks can't be reopened and their Samples can't be reused.",
  'prepare.clearsHandoff': 'Clears the Tray bay records of all Modules.',
  'reason.prepareActiveBatches':
    'Tasks are running or waiting — stop or discard them first: {names}',
  'reason.prepareBatchesLoading': 'Loading Tasks',
  'reason.prepareBatchesUnknown': "Couldn't read Tasks, so this can't be decided — {message}",
  'action.clearHandoff': 'Clear Tray bay',
  'prepare.drawerResult': 'Clear Tray bay result',
  'row.prepareBatches': 'Tasks to close now',
  'row.prepareModules': 'Modules to reset',
  'row.prepareClosed': 'Closed Tasks',
  'row.prepareReady': 'Readiness',
  'value.prepareReady': 'Tasks can start',
  'value.prepareNotReady': "Can't start yet",
  'state.empty.activeBatches': 'No Task in progress',
  'enum.systemMode.normal': 'Normal',
  'enum.systemMode.maintenance': 'Maintenance',
  'enum.systemMode.calibration': 'Calibration',
  'enum.systemMode.simulation': 'Simulation',
  'enum.systemMode.startup': 'Starting up',
  'enum.systemMode.shutdown': 'Shutdown',
  'enum.pwComplexity.low': 'Low',
  'enum.pwComplexity.mid': 'Medium',
  'enum.pwComplexity.high': 'High',
  'enum.userStatus.active': 'Active',
  'enum.userStatus.locked': 'Locked',
  'enum.userStatus.disabled': 'Inactive',
  'unit.chars': 'chars',
  'unit.times': 'times',
  'unit.count': 'pcs',
  'unit.days': 'days',
  'unit.minutes': 'min',
  'unit.hours': 'h',
  'unit.seconds': 's',
  'unit.percent': '%',
  'unit.years': 'yrs',
  'card.account': 'Account',
  'card.activeSessions': 'Active sessions',
  'card.recentAudit': 'Recent audit',
  'row.created': 'Created',
  'row.lastLogin': 'Last login',
  'row.failCount': 'Failed attempts',
  'column.device': 'Device',
  'column.loggedInAt': 'Login',
  'value.currentSession': 'Current',
  'value.thisDevice': 'This device',
  'field.accountId': 'Account ID',
  'field.userName': 'Name',
  'field.password': 'Password',
  'field.passwordConfirm': 'Confirm password',
  'field.email': 'Email (optional)',
  'field.role': 'Role',
  'field.currentPassword': 'Current password',
  'field.newPassword': 'New password',
  'field.newPasswordConfirm': 'Confirm new password',
  'screen.passwordChange.title': 'Change password',
  'value.passwordChangedAt': 'Changed {time}',
  'section.sessions': 'Sessions',
  'section.loginInfo': 'Login info',
  'section.preferences': 'Preferences',
  'setting.language': 'Language',
  'locale.ko': '한국어',
  'state.empty.audit': 'No records',
  'state.empty.users': 'No users',
  'reason.currentSession': 'Session in use',
  'reason.onlySession': 'No other sessions',
  'validation.password.mismatch': "Passwords don't match",
  'validation.login.usernameRequired': 'Enter your ID',
  'validation.login.passwordRequired': 'Enter your password',
  'validation.required': 'Enter a value',
  'validation.choiceRequired': 'Select one',
  'validation.reasonRequired': 'Enter a reason',
  'validation.nameRequired': 'Enter a name',
  'validation.sampleIdRequired': 'Enter a Sample ID',
  'validation.sampleIdInList': 'This ID is already in the added Samples — enter another',
  'validation.sampleIdTaken': 'This Sample ID is already registered — enter another',
  'validation.sampleTypeRequired': 'Select a type',
  'validation.drawAtInvalid': 'Re-enter the draw date & time',
  'validation.extrasInvalid': 'Fix the marked items in the extra fields',
  'validation.sampleRowsRequired': 'Add at least one Sample',
  'validation.sampleListErrors': 'Fix the marked fields in the added Samples',
  'validation.correctionReasonRequired': 'Enter a correction reason',
  'validation.recipeRequired': 'Select a Recipe',
  'validation.samplesRequired': 'Select Samples',
  'validation.wellsUnassigned': 'Assign Samples to the empty wells',
  'validation.recipeNameRequired': 'Enter a Recipe name',
  'validation.recipeFormIssues': 'Fields to fix: {count} — fix the marked fields',
  'validation.recipeJsonRequired': 'Paste the Recipe JSON',
  'validation.baseRecipeRequired': 'Select a Recipe to clone',
  'validation.accountIdRequired': 'Enter an account ID',
  'validation.userNameRequired': 'Enter a name',
  'validation.roleRequired': 'Select a role',
  'validation.password.required': 'Enter a password',
  'validation.password.currentRequired': 'Enter the current password',
  'validation.password.newRequired': 'Enter a new password',
  'validation.password.confirmRequired': 'Enter the password confirmation',
  'screen.stops.title': 'Active stops',
  'screen.stopsRelease.title': 'Release all',
  'action.releaseStops': 'Release',
  'action.approveReleaseStops': 'Approve release',
  'column.stopKind': 'Type',
  'column.stopTarget': 'Target',
  'column.stopSaid': 'Details',
  'column.stopReleasable': 'Release',
  'column.stopErrorCode': 'Error code',
  'stops.kind.safety': 'Safety Stop',
  'stops.kind.module_hold': 'Module hold',
  'stops.kind.robot_holding': 'Holding robot',
  'stops.kind.door_open': 'Open door',
  'stops.kind.quarantine': 'Handoff quarantine',
  'stops.releasable.yes': 'Releasable',
  'stops.releasable.no': 'Person first',
  'stops.releasable.withParent': 'Released together',
  'state.empty.stops': 'No active stops',
  'stops.alarmsOpen': 'Open Alarms: {count} (for reference)',
  'stops.confirmIntro': 'Releases the items below in order, all at once.',
  'stops.releasableLabel': 'Releasable',
  'stops.humanFirst': 'For a person to do first — not released here',
  'stops.noResume':
    "Releasing doesn't resume the Task. After release, press [Resume] on the Task screen.",
  'stops.physicalCheck': 'I checked the held Tray, robot arm area and doors on site',
  'stops.resultLabel': 'Release result',
  'stops.result.done': 'Released',
  'stops.result.notDone': 'Not released',
  'reason.noReleasableStops': 'Nothing to release',
  'reason.physicalCheckRequired': 'Tick the on-site check box',
  'alarmRecipients.selection.title': 'Alarms to receive',
  'alarmRecipients.selection.all': 'All Alarms',
  'alarmRecipients.selection.off': "Don't send",
  'alarmRecipients.selection.none': "None selected — don't send",
  'alarmRecipients.selection.count': 'Alarms selected: {count}',
  'alarmRecipients.selection.clear': 'Clear selection',
  'alarmRecipients.selection.search': 'Search Alarm code · content',
  'alarmRecipients.selection.groupAll': 'Select all {group}',
  'alarmRecipients.selection.groupCount': '{selected}/{total} selected',
  'alarmRecipients.selection.noResults': 'No results',
  'alarmRecipients.title': 'Notification recipients',
  'alarmRecipients.intro':
    'Where Alarms are received remotely. [Send test] sends one test message only and leaves no Alarm or audit record.',
  'alarmRecipients.empty': 'No recipients registered',
  'alarmRecipients.adminOnly': 'For admin only — viewing requires the settings permission',
  'alarmRecipients.column.name': 'Name',
  'alarmRecipients.column.kind': 'Type',
  'alarmRecipients.column.enabled': 'Enabled',
  'alarmRecipients.column.minSeverity': 'Min severity',
  'alarmRecipients.column.filter': 'Filter',
  'alarmRecipients.column.role': 'Role',
  'alarmRecipients.column.url': 'URL',
  'alarmRecipients.column.actions': 'Actions',
  'alarmRecipients.column.sources': 'Sources',
  'alarmRecipients.column.errorCodes': 'Alarm codes',
  'alarmRecipients.kind.webhook': 'Webhook',
  'alarmRecipients.kind.slack': 'Slack',
  'alarmRecipients.role.all': 'All',
  'alarmRecipients.role.escalation': 'Escalation only',
  'alarmRecipients.role.backup': 'Backup',
  'alarmRecipients.roleHelp.all': 'Receives first notices and escalations',
  'alarmRecipients.roleHelp.escalation': 'Receives escalations for unacknowledged Alarms only',
  'alarmRecipients.roleHelp.backup': 'Receives only when all other recipients failed',
  'alarmRecipients.enabled.on': 'On',
  'alarmRecipients.enabled.off': 'Off',
  'alarmRecipients.toggleLabel': '{name} enabled',
  'alarmRecipients.severityLabel': '{name} min severity',
  'alarmRecipients.roleLabel': '{name} role',
  'alarmRecipients.filter.all': 'All',
  'alarmRecipients.filter.summary': 'Sources {sources} · codes {codes}',
  'alarmRecipients.filter.allLabel': 'All (no filter)',
  'alarmRecipients.filter.noCandidates': 'No candidates — type one in',
  'alarmRecipients.filter.typePlaceholder': 'Type in',
  'alarmRecipients.url.set': 'Set',
  'alarmRecipients.url.unset': 'Not set',
  'alarmRecipients.url.placeholderNew': 'http:// or https:// URL',
  'alarmRecipients.url.placeholderKeep': 'Set — leave empty to keep',
  'alarmRecipients.url.placeholderNone': 'No URL — enter one to set it',
  'alarmRecipients.action.add': '＋ Add recipient',
  'alarmRecipients.action.edit': 'Edit',
  'alarmRecipients.action.delete': 'Delete',
  'alarmRecipients.action.test': 'Send test',
  'alarmRecipients.action.save': 'Save',
  'alarmRecipients.action.addTyped': 'Add',
  'alarmRecipients.form.addTitle': 'Add notification recipient',
  'alarmRecipients.form.editTitle': 'Edit notification recipient',
  'alarmRecipients.reason.urlRequired': 'Enter a URL',
  'alarmRecipients.reason.noChange': 'No fields changed',
  'alarmRecipients.reason.typeFirst': 'Enter a value first',
  'alarmRecipients.rejected': 'Server rejection reason',
  'alarmRecipients.test.ok': 'Send test — success · HTTP {status}',
  'alarmRecipients.test.failed': 'Send test — failed · {reason}',
  'alarmRecipients.test.error': "Couldn't send the test — {reason}",
  'alarmRecipients.deleteTitle': 'Delete {name}',
  'alarmRecipients.deleteBody':
    'Nothing more is sent to this recipient. Existing send records show it as “Deleted recipient”.',
  'alarmRecipients.dispatch.none': 'No send records',
  'alarmRecipients.dispatch.deleted': 'Deleted recipient',
  'alarmRecipients.dispatch.col.channel': 'Recipient',
  'alarmRecipients.dispatch.col.attempts': 'Attempts',
  'alarmRecipients.dispatch.col.sentAt': 'Sent at',
  'alarmRecipients.dispatch.kind.initial': 'First notice',
  'alarmRecipients.dispatch.kind.fallback': 'Fallback',
  'alarmRecipients.dispatch.kind.escalation': 'Escalation',
  'alarmRecipients.dispatch.state.pending': 'Waiting',
  'alarmRecipients.dispatch.state.sent': 'Sent',
  'alarmRecipients.dispatch.state.failed': 'Failed',
  'alarmRecipients.dispatch.attempts': 'Attempts: {count}',
  'alarmSettings.adminOnly': 'For admin only — changing this requires the settings permission',
  'alarmSettings.remote.offWarning': 'Remote Alarms are off on the server, so nothing is sent',
  'alarmSettings.remote.turnOn': 'Turn on',
  'alarmSettings.channels.title': 'Registered Webhooks',
  'alarmSettings.hooks.empty': 'No Webhooks registered',
  'alarmSettings.hooks.urlUnset': 'No URL',
  'alarmSettings.hooks.col.alarms': 'Alarms received',
  'alarmSettings.hooks.state.on': 'On',
  'alarmSettings.hooks.state.off': 'Off',
  'alarmSettings.hooks.detailTitle': 'Webhook details',
  'alarmSettings.hooks.notFound': "That Webhook can't be found",
  'alarmSettings.hooks.add': '＋ Add Webhook',
  'alarmSettings.hooks.addTitle': 'Add Webhook',
  'alarmSettings.action.enable': 'Enable',
  'alarmSettings.action.enableLabel': 'Enable {name}',
  'alarmSettings.channel.slack': 'Slack',
  'alarmSettings.channel.discord': 'Discord',
  'alarmSettings.channel.googleChat': 'Google Chat',
  'alarmSettings.channel.webhook': 'Webhook',
  'alarmSettings.channel.filtered':
    'This channel is off or saved to receive only some severities, so not all Alarms arrive',
  'alarmSettings.action.receiveAll': 'Set to receive all',
  'alarmSettings.action.test': 'Send test',
  'alarmSettings.form.url': 'Webhook URL',
  'alarmSettings.form.urlRequired': 'Enter a URL',
  'alarmSettings.form.save': 'Save',
  'alarmSettings.channel.pick': 'Channel',
  'alarmSettings.channel.notYet': "This channel can't be connected yet",
  'alarmSettings.form.urlHelp': 'How to get a Webhook URL',
  'alarmSettings.channel.help.googleChat':
    'In a Google Chat space → Apps & integrations → Manage webhooks → Add webhook, set a name and save to get the URL.',
  'alarmSettings.channel.help.discord':
    'In Discord Server Settings → Integrations → Webhooks → New Webhook, choose the channel and click “Copy Webhook URL”.',
  'alarmSettings.channel.help.slack':
    'In Slack app settings (api.slack.com/apps) → turn on Incoming Webhooks → Add New Webhook, choose a channel to get the URL.',
  'alarmSettings.form.name': 'Name',
  'alarmSettings.form.urlKeep': 'Set — leave empty to keep',
  'alarmSettings.form.urlPlaceholder.googleChat':
    'https://chat.googleapis.com/v1/spaces/…/messages?key=…&token=…',
  'alarmSettings.form.urlPlaceholder.discord': 'https://discord.com/api/webhooks/…/…',
  'alarmSettings.form.urlPlaceholder.slack': 'https://hooks.slack.com/services/…',
  'alarmSettings.form.urlPlaceholder.webhook': 'https://…',
  'alarmSettings.form.urlShape.googleChat':
    'Not a Google Chat Webhook URL — https://chat.googleapis.com/v1/spaces/…/messages?key=…&token=…',
  'alarmSettings.form.urlShape.discord':
    'Not a Discord Webhook URL — https://discord.com/api/webhooks/{id}/{token}',
  'alarmSettings.form.urlShape.slack':
    'Not a Slack Incoming Webhook URL — https://hooks.slack.com/services/…',
  'alarmSettings.form.urlShape.webhook': 'The URL must start with http:// or https://',
  'alarmSettings.reason.noChange': 'No fields changed',
  'alarmSettings.routing.title': 'Per-Alarm delivery',
  'alarmSettings.routing.cardTitle': 'Per-Alarm settings',
  'alarmSettings.routing.edit': 'Edit',
  'alarmSettings.routing.done': 'Done',
  'alarmSettings.routing.identity': 'Name · URL',
  'alarmSettings.routing.editOff': 'This Webhook is off — press [Enable] first',
  'alarmSettings.routing.intro':
    'Alarms are sent through the routes you turn on. Expand a row to see the situation and actions.',
  'alarmSettings.routing.empty': 'No matching Alarms',
  'alarmSettings.routing.seen': 'Has occurred',
  'alarmSettings.routing.unknownCode': 'Code not in the dictionary — shown as saved',
  'alarmSettings.routing.col.message': 'Content',
  'alarmSettings.routing.expand.description': 'Situation',
  'alarmSettings.routing.expand.actions': 'Actions',
  'alarmSettings.routing.col.code': 'Alarm',
  'alarmSettings.routing.col.severity': 'Severity',
  'alarmSettings.routing.toggle': '{code} — {channel}',
  'alarmSettings.routing.belowMin': 'Below severity',
  'alarmSettings.routing.col.remote': 'Remote notification',
  'alarmSettings.routing.remote.none':
    'No channel connected — connect one in the channel card above',
  'alarmSettings.routing.remote.partial': 'Partial',
  'alarmSettings.routing.group.count': 'Types: {count}',
  'alarmSettings.routing.group.toggle': 'All {group} — {channel}',
  'alarmSettings.routing.group.codes': '{group} Alarm types: {count}',
  'alarmSettings.routing.remote.failed': "Couldn't save to {channels} — {reason}",
  'alarmSettings.routing.confirmTitle': 'Remote notification — switch to selected Alarms only',
  'alarmSettings.routing.confirmBody':
    "{channels} currently receive all Alarms. Turning off {code} means only the remaining dictionary Alarms are received — codes added to the dictionary later won't be.",
  'alarmSettings.routing.confirm': 'Change',
  'alarmPopup.title': 'New Alarms: {count}',
  'alarmPopup.open': 'Go to Alarms',
  'alarmPopup.close': 'Close',
  'alarmPopup.note': "Closing doesn't acknowledge Alarms. Acknowledge them on the Alarm screen.",
  'positionRegistry.title': 'Position registry',
  'positionRegistry.intro':
    "A list of Point names. Coordinates aren't stored here. Points are deactivated, not deleted — changes apply from new Tasks on.",
  'positionRegistry.idPlaceholder': '<module type>.<bay> — e.g. staining.deck-7',
  'positionRegistry.none': 'None',
  'positionRegistry.noChoices': 'The server gave no options',
  'positionRegistry.noAxes': 'This owner Module has no aux axes to choose',
  'positionRegistry.protected': 'Protected — {why}',
  'positionRegistry.summary':
    '{shown} / {total} Points · taught {taught} · unknown to Module {unsynced}',
  'positionRegistry.empty': 'No matching Points',
  'positionRegistry.field.position_id': 'Name',
  'positionRegistry.field.owner': 'Owner Module',
  'positionRegistry.field.frame': 'Frame',
  'positionRegistry.field.kind': 'Type',
  'positionRegistry.field.dof': 'DoF',
  'positionRegistry.field.station': 'Station',
  'positionRegistry.field.approach': 'Approach',
  'positionRegistry.field.labware_rotation_deg': 'Labware rotation (°)',
  'positionRegistry.field.deck_slot': 'Deck slot',
  'positionRegistry.field.axes': 'Aux axes',
  'positionRegistry.field.slide_axis': 'Slide axis',
  'positionRegistry.field.serves': 'Served Modules',
  'positionRegistry.field.d1_exempt_why': 'Station sharing reason',
  'positionRegistry.field.note': 'Note',
  'positionRegistry.field.source': 'Evidence',
  'positionRegistry.field.status': 'Status',
  'positionRegistry.status.active': 'Active',
  'positionRegistry.status.disabled': 'Inactive',
  'positionRegistry.column.taught': 'Teaching',
  'positionRegistry.column.synced': 'Module',
  'positionRegistry.column.actions': 'Actions',
  'positionRegistry.taught.yes': 'Taught',
  'positionRegistry.taught.no': 'Not taught',
  'positionRegistry.synced.yes': 'Known to Module',
  'positionRegistry.synced.no': "Unknown to Module — can't teach",
  'positionRegistry.action.add': '+ New Point',
  'positionRegistry.action.edit': 'Edit',
  'positionRegistry.action.disable': 'Deactivate',
  'positionRegistry.action.enable': 'Reactivate',
  'positionRegistry.action.save': 'Save',
  'positionRegistry.filter.all': 'All',
  'positionRegistry.filter.showDisabled': 'Show inactive',
  'positionRegistry.form.addTitle': 'New Point',
  'positionRegistry.form.editTitle': 'Edit Point — {id}',
  'positionRegistry.reason.noChange': 'No fields changed',
  'positionRegistry.reject.protected':
    "This Point is protected: active state, type and owner Module can't be changed — {why}",
  'positionRegistry.reject.inUse':
    "Can't deactivate: non-archived Recipes ({count}) use this Point as a Labware bay",
  'positionRegistry.reject.idTaken': 'A Point with this name already exists (including inactive)',
  'userSessionPolicy.title': 'Session expiry',
  'userSessionPolicy.access': 'Access token',
  'userSessionPolicy.idle': 'Idle expiry',
  'userSessionPolicy.absolute': 'Absolute limit',
  'userSessionPolicy.source.user': 'Account setting',
  'userSessionPolicy.source.role': 'Role setting ({role})',
  'userSessionPolicy.source.default': 'Global setting',
  'userSessionPolicy.source.base': 'Default',
  'userSessionPolicy.unit.hours': '{count} h',
  'userSessionPolicy.unit.minutes': '{count} min',
  'userSessionPolicy.unit.seconds': '{count} s',
  'userSessionPolicy.belowCycle':
    'The absolute limit is shorter than the unattended cycle — sessions may end during unattended operation',
  'userSessionPolicy.userTier': '{label} — this account',
  'policy.section.session': 'Session expiry',
  'policy.section.security': 'Password · login lock',
  'policy.section.controlLock': 'Control Lock',
  'policy.adminOnly': 'For admin only — viewing requires the settings permission',
  'policy.invalidNumber': 'Enter an integer of 1 or more',
  'policy.scope.base': 'Default',
  'policy.scope.default': 'Global',
  'policy.scope.role': 'Role · {id}',
  'policy.scope.user': 'Account · {id}',
  'policy.column.scope': 'Tier',
  'policy.column.minutes': '{label} (min)',
  'policy.column.updated': 'Updated',
  'policy.column.updatedBy': 'Updated by',
  'policy.placeholder.base': 'Default {value}',
  'policy.placeholder.inherit': 'Inherit',
  'policy.unit.minutes': 'min',
  'policy.unit.seconds': 's',
  'policy.unit.chars': 'chars',
  'policy.unit.times': 'times',
  'policy.session.defaults':
    'Defaults — access token {access} · idle expiry {idle} · absolute limit {absolute} · unattended cycle {cycle}. Empty fields inherit from the upper tier (account → role → global → default)',
  'policy.session.belowCycle':
    'Tiers with an absolute limit shorter than the unattended cycle ({cycle}): {scopes}',
  'policy.security.minLen': 'Min password length',
  'policy.security.maxLen': 'Max password length',
  'policy.security.lockThreshold': 'Login failures before lock',
  'policy.security.lockMinutes': 'Login lock duration',
  'policy.lock.ttl': 'Control Lock lifetime',
  'policy.lock.heartbeat': 'Control Lock renewal interval',
  'policy.value.base': '{value} {unit} · default',
  'policy.value.set': '{value} {unit} · set (default {base})',
  'reason.quickBatchNoRecipe': 'No Recipe set — fill in VITE_DEV_QUICK_BATCH_RECIPE',
  'broker.title': 'Broker accounts',
  'broker.intro':
    'Accounts the Modules and Core use to connect to the MQTT broker. Turning off, deleting, or changing a password or role can disconnect Modules using that account.',
  'broker.empty': 'No broker accounts',
  'broker.adminOnly': 'For admin only — only admin can view broker accounts and connections',
  'broker.column.name': 'Account',
  'broker.column.kind': 'Type',
  'broker.column.modules': 'Connected Modules',
  'broker.column.state': 'Status',
  'broker.column.lastConnected': 'Last connected',
  'broker.column.sync': 'Sync',
  'broker.column.actions': 'Actions',
  'broker.kind.module': 'Module',
  'broker.kind.l2': 'Core (L2)',
  'broker.kind.admin': 'Admin',
  'broker.tag.test': 'Test account',
  'broker.tag.unused': 'Unused',
  'broker.state.enabled': 'On',
  'broker.state.disabled': 'Off',
  'broker.modules.none': 'None',
  'broker.last.unknown': 'No record',
  'broker.sync.ok': 'In sync',
  'broker.sync.differs': 'Out of sync',
  'broker.sync.unknown': 'Unknown',
  'broker.action.manage': 'Manage',
  'broker.action.roles': 'Change roles',
  'broker.action.enable': 'Turn on',
  'broker.action.disable': 'Turn off',
  'broker.action.password': 'Change password',
  'broker.action.delete': 'Delete account',
  'broker.dialog.title': 'Broker account · {name}',
  'broker.dialog.actions': 'Actions',
  'broker.history.title': 'Action history',
  'broker.history.empty': 'No action history',
  'broker.history.at': 'Time',
  'broker.history.operation': 'Action',
  'broker.history.outcome': 'Result',
  'broker.history.actor': 'Actor',
  'broker.history.ok': 'Success',
  'broker.op.createBrokerAccount': 'Create account',
  'broker.op.setBrokerAccountRoles': 'Change roles',
  'broker.op.disableBrokerAccount': 'Turn off',
  'broker.op.enableBrokerAccount': 'Turn on',
  'broker.op.changeBrokerPassword': 'Change password',
  'broker.op.deleteBrokerAccount': 'Delete account',
  'broker.op.switchCoreBrokerAccount': 'Switch Core account',
  'broker.op.changeModuleBrokerConnection': 'Change Module connection',
  'broker.roles.title': 'Change roles · {name}',
  'broker.roles.help':
    "Can publish only to the selected Modules' topics. The selection replaces «all» current roles — Modules left out can't publish with this account.",
  'broker.roles.noCandidates': 'No Modules to choose',
  'broker.roles.allRemoved':
    "Removes all roles — Modules connected with this account can't publish",
  'broker.roles.noChange': 'No roles changed',
  'broker.disable.title': 'Turn off account · {name}',
  'broker.disable.body':
    'Turning it off disconnects Modules using this account ({modules}) from the broker. You can undo this with [Turn on].',
  'broker.disable.bodyNoModule':
    'Turning it off blocks broker connections with this account. You can undo this with [Turn on].',
  'broker.password.title': 'Change password · {name}',
  'broker.password.body':
    "The server creates a new password and sends it to connected Modules first. If a Module doesn't accept it, the broker isn't changed.",
  'broker.password.bodyCore':
    'This is the account the Core uses now. The server changes it to a new password, then tests the connection; if that fails, it restores the old value. Afterwards, set the same password in the Core .env.',
  'broker.password.once':
    "The new password is shown only once on the next screen. It can't be retrieved again.",
  'broker.password.showOnce':
    "New password — it can't be viewed again after closing this window. If a Module screen needs it, copy it now.",
  'broker.password.copy': 'Copy password',
  'broker.password.replayed':
    'Request already processed — the password is only in the first response',
  'broker.delete.title': 'Delete account · {name}',
  'broker.delete.body':
    'It is turned off first and connections are observed. If all connected Modules move to other accounts, it is deleted; if they only drop off, it is turned back on (rollback). Connected Modules disconnect the moment it turns off.',
  'broker.delete.confirmLabel': 'Re-enter the account name',
  'broker.delete.reason.confirmName': 'The account name must match to delete',
  'broker.change.state': 'Progress',
  'broker.change.deadline': 'Observation deadline',
  'broker.change.reason': 'Reason',
  'broker.change.started.password': 'Password change started',
  'broker.change.started.delete':
    'Account deletion started — now off; after observing, the server deletes it or turns it back on',
  'broker.change.started.core_switch': 'Core account switch started',
  'broker.change.started.provision': 'Account provisioning started',
  'broker.change.started.connection':
    'Connection change started — observing whether the Module connects to the new address',
  'broker.change.started.identity':
    'Module ID change started — the registry updates when the new ID arrives',
  'broker.change.started.release': 'Role release started',
  'broker.changeState.in_progress': 'In progress',
  'broker.changeState.done': 'Done',
  'broker.changeState.rolled_back': 'Rolled back',
  'broker.changeState.undecided': 'Undetermined — needs a person to check',
  'broker.reason.protected_test':
    "Test account — used by broker permission tests, so it isn't changed",
  'broker.reason.protected_admin': "Admin account — the Core's broker admin account isn't changed",
  'broker.reason.protected_l2':
    "Core (L2) account — can't be turned off, deleted or have roles changed",
  'broker.reason.protected_l2Other':
    "Not the account the Core uses now — only the Core's own account password can be changed",
  'broker.reason.coreUnknown': "Couldn't determine the account the Core uses",
  'broker.reason.alreadyDisabled': 'Already off',
  'broker.reason.alreadyEnabled': 'Already on',
  'broker.reason.batch_active': "Task {batch} is running, so the broker can't be changed",
  'broker.reason.change_in_progress':
    'A change for the same account or Module is in progress — try again when it ends',
  'broker.reason.protected_account': "Core, admin and test accounts can't be changed",
  'broker.reason.module_not_acknowledged':
    "The Module didn't accept the new settings — the broker wasn't changed",
  'broker.reason.account_name_taken': 'An account with this name already exists',
  'broker.reason.account_in_use': 'A client is connected with that account now',
  'broker.reason.control_unconfigured':
    "This server's broker doesn't support account control — broker admin credentials aren't configured",
  'broker.reason.control_unreachable': "Couldn't reach the broker — nothing changed",
  'broker.reason.control_timeout': "The broker didn't respond in time — unknown whether it changed",
  'broker.reason.not_found': 'Account or Module not found — check the list again',
  'broker.reason.same_id': 'The new ID is the same as the current ID',
  'broker.reason.confirm_mismatch': "The re-entered current ID doesn't match",
  'broker.reason.id_format': 'Not a valid Module ID format',
  'broker.reason.id_taken': 'That ID is already registered',
  'broker.reason.same_address': 'Same as the current address',
  'broker.reason.confirm_address_change_required': 'Tick the confirmation to change the address',
  'broker.connection.address': 'Broker address',
  'tab.logs.replenish': 'Refill log',
  'tab.logs.waste': 'Waste bin change',
  'filter.search.records': 'Search Module · bin · note',
  'state.empty.replenishments': 'No refill records',
  'state.empty.wasteReplacements': 'No change records',
  'records.column.module': 'Module',
  'records.column.after': 'After refill',
  'records.column.container': 'Waste bin',
  'records.column.note': 'Note',
  'records.replenish.kind.tip': 'Tip',
  'records.replenish.kind.tc': 'TC',
  'records.replenish.kind.reagent': 'Reagent',
  'records.replenish.resetFull': 'Reset to full',
  'records.replenish.countAfter': '{count} pcs',
  'records.replenish.reagentAfter': '{labware} · {wells} · {volume} µL per well',
  'records.attribution.authenticated_session': 'Login session',
  'records.attribution.batch_owner': 'Task owner',
  'records.attribution.maintenance_session': 'Maintenance session',
  'locale.en': 'English',
  'unit.kinds': 'types',
  'error.requestTimeout': 'The request timed out',
  'error.eventTotalUnknown': 'Could not determine the total number of events.',
  'error.historyIncomplete':
    'The history query reached its limit, so the full record could not be checked.',
  'error.standardRecipeMissing': 'Could not load the standard recipe',
  'sampleNew.hints.type.test': 'Test',
  'sampleNew.hints.type.validation': 'Validation',
  'sampleNew.hints.type.other': 'Other',
}
